// scholars data structure
import { ScholarCard } from '../types/fiqhData';

const scholars: ScholarCard[] = [
  {
    id: 1,
    name: "Abu Bakr al-Siddiq",
    arabicName: "أبو بكر الصديق",
    title: "First Caliph",
    born: { hijri: -12, gregorian: 573 },
    died: { hijri: 13, gregorian: 634 },
    location: "Mecca, Saudi Arabia",
    rarity: "legendary",
    level: 99,
    era: "Sahaba",
    madhab: "",
    expertise: ["Leadership", "Wisdom", "Loyalty"],
    specialAbility: "Rightly Guided Leader",
    stats: {
      knowledge: 90,
      influence: 99,
      piety: 98,
      works: 85,
      leadership: 99
    },
    bio: "Abu Bakr al-Siddiq was a senior companion and father-in-law of the Islamic prophet Muhammad, and the first of the Rashidun caliphs who ruled from 632 to 634.",
    majorWorks: [
      "Establishment of Islamic State",
      "Compilation of Quran",
      "Ridda Wars"
    ],
    notableFor: [
      "First adult male to convert to Islam",
      "Closest companion of Prophet Muhammad",
      "First Caliph of Islam"
    ],
    colorTheme: {
      primary: "from-yellow-500",
      secondary: "to-orange-600"
    }
  },
  {
    id: 2,
    name: "Umar ibn al-Khattab",
    arabicName: "عمر بن الخطاب",
    title: "Second Caliph",
    born: { hijri: -20, gregorian: 584 },
    died: { hijri: 23, gregorian: 644 },
    location: "Mecca, Saudi Arabia",
    rarity: "legendary",
    level: 98,
    era: "Sahaba",
    madhab: "",
    expertise: ["Justice", "Strength", "Strategy"],
    specialAbility: "Justice Incarnate",
    stats: {
      knowledge: 92,
      influence: 99,
      piety: 97,
      works: 88,
      leadership: 98
    },
    bio: "Umar ibn al-Khattab was a leading companion and the second of the Rashidun caliphs of the Islamic community, ruling from 634 until his assassination in 644.",
    majorWorks: [
      "Expansion of Islamic Empire",
      "Establishment of Islamic Government",
      "Hijri Calendar System"
    ],
    notableFor: [
      "Just ruler and reformer",
      "Great military strategist",
      "Established administrative systems"
    ],
    colorTheme: {
      primary: "from-red-500",
      secondary: "to-pink-600"
    }
  },
  {
    id: 3,
    name: "Uthman ibn Affan",
    arabicName: "عثمان بن عفان",
    title: "Third Caliph",
    born: { hijri: -18, gregorian: 576 },
    died: { hijri: 35, gregorian: 656 },
    location: "Mecca, Saudi Arabia",
    rarity: "legendary",
    level: 97,
    era: "Sahaba",
    madhab: "",
    expertise: ["Generosity", "Quran Preservation", "Leadership"],
    specialAbility: "Keeper of Two Qiblas",
    stats: {
      knowledge: 89,
      influence: 98,
      piety: 99,
      works: 95,
      leadership: 95
    },
    bio: "Uthman ibn Affan was the third Rashidun caliph of the Islamic community. He was one of the earliest and youngest converts to Islam.",
    majorWorks: [
      "Compilation of Quran in one manuscript",
      "Standardization of Quranic text",
      "Expansion of Islamic territories"
    ],
    notableFor: [
      "Compiler of the Quran",
      "Great generosity",
      "Established official Quranic text"
    ],
    colorTheme: {
      primary: "from-blue-500",
      secondary: "to-cyan-600"
    }
  },
  {
    id: 4,
    name: "Ali ibn Abi Talib",
    arabicName: "علي بن أبي طالب",
    title: "Fourth Caliph",
    born: { hijri: -13, gregorian: 601 },
    died: { hijri: 40, gregorian: 661 },
    location: "Mecca, Saudi Arabia",
    rarity: "legendary",
    level: 99,
    era: "Sahaba",
    madhab: "",
    expertise: ["Knowledge", "Bravery", "Eloquence"],
    specialAbility: "Lion of Allah",
    stats: {
      knowledge: 99,
      influence: 98,
      piety: 97,
      works: 92,
      leadership: 96
    },
    bio: "Ali ibn Abi Talib was the cousin and son-in-law of the Islamic prophet Muhammad, ruling from 656 to 661. He is considered the first Imam by Shi'ite Muslims.",
    majorWorks: [
      "Nahj al-Balagha",
      "Establishment of Islamic jurisprudence",
      "Champion of justice"
    ],
    notableFor: [
      "First male to embrace Islam",
      "Master of Islamic jurisprudence",
      "Symbol of courage and justice"
    ],
    colorTheme: {
      primary: "from-purple-600",
      secondary: "to-indigo-700"
    }
  },
  {
    id: 5,
    name: "Sufyan al-Thawri",
    arabicName: "سفيان الثوري",
    title: "Hadith Master",
    born: { hijri: 97, gregorian: 716 },
    died: { hijri: 161, gregorian: 778 },
    location: "Kufa, Iraq",
    rarity: "epic",
    level: 95,
    era: "Tabi'un",
    madhab: "",
    expertise: ["Hadith", "Fiqh", "Piety"],
    specialAbility: "Master of Authentic Hadith",
    stats: {
      knowledge: 96,
      influence: 94,
      piety: 98,
      works: 89,
      leadership: 87
    },
    bio: "Sufyan al-Thawri was an important jurist and theologian of early Islam, and one of the most prominent hadith masters of his time.",
    majorWorks: [
      "Musnad Sufyan al-Thawri",
      "Various legal opinions",
      "Hadith compilations"
    ],
    notableFor: [
      "Pillar of Hadith Sciences",
      "Founder of systematic Hadith authentication",
      "Exemplary piety and learning"
    ],
    colorTheme: {
      primary: "from-green-500",
      secondary: "to-teal-600"
    }
  },
  {
    id: 6,
    name: "Imam Abu Hanifa",
    arabicName: "أبو حنيفة النعمان",
    title: "Imam of the Iraqis",
    born: { hijri: 80, gregorian: 699 },
    died: { hijri: 150, gregorian: 767 },
    location: "Kufa, Iraq",
    rarity: "legendary",
    level: 99,
    era: "Tabi'un",
    madhab: "Hanafi",
    expertise: ["Fiqh", "Jurisprudence", "Legal Theory"],
    specialAbility: "Founder of Systematic Jurisprudence",
    stats: {
      knowledge: 95,
      influence: 98,
      piety: 92,
      works: 88,
      leadership: 90
    },
    bio: "Imam Abu Hanifa was an Iraqi theologian and jurist of Persian origin, known as the founder of the Hanafi school of Sunni jurisprudence. His school is followed by approximately half of Muslims worldwide.",
    majorWorks: [
      "Al-Fiqh al-Akbar",
      "Al-Fiqh al-Asghar",
      "Musnad al-Rabi ibn Khuthaym"
    ],
    notableFor: [
      "Systematic approach to Islamic jurisprudence",
      "Founder of the Hanafi madhab",
      "Emphasis on reason and analogy (ra'y)"
    ],
    colorTheme: {
      primary: "from-yellow-500",
      secondary: "to-orange-600"
    }
  },
  {
    id: 7,
    name: "Imam Malik ibn Anas",
    arabicName: "مالك بن أنس",
    title: "Imam of the Hejaz",
    born: { hijri: 93, gregorian: 711 },
    died: { hijri: 179, gregorian: 795 },
    location: "Medina, Saudi Arabia",
    rarity: "legendary",
    level: 97,
    era: "Tabi'un",
    madhab: "Maliki",
    expertise: ["Hadith", "Fiqh", "Jurisprudence"],
    specialAbility: "Keeper of Prophetic Traditions",
    stats: {
      knowledge: 97,
      influence: 95,
      piety: 94,
      works: 90,
      leadership: 88
    },
    bio: "Imam Malik ibn Anas was a Muslim jurist, Islamic scholar, and hadith traditionist who became the influential master of the Medina community. He founded the Maliki school of Islamic jurisprudence.",
    majorWorks: [
      "Al-Muwatta",
      "Al-Mudawwana"
    ],
    notableFor: [
      "Compiler of Al-Muwatta, one of earliest Hadith collections",
      "Founder of the Maliki madhab",
      "Focus on practice of the people of Medina"
    ],
    colorTheme: {
      primary: "from-purple-600",
      secondary: "to-blue-600"
    }
  },
  {
    id: 8,
    name: "Imam al-Shafi'i",
    arabicName: "الشافعي",
    title: "Revolutionary of Jurisprudence",
    born: { hijri: 150, gregorian: 767 },
    died: { hijri: 204, gregorian: 820 },
    location: "Gaza, Palestine",
    rarity: "legendary",
    level: 98,
    era: "Abbasid",
    madhab: "Shafi'i",
    expertise: ["Fiqh", "Usul al-Fiqh", "Hadith"],
    specialAbility: "Systematizer of Legal Methodology",
    stats: {
      knowledge: 98,
      influence: 97,
      piety: 91,
      works: 92,
      leadership: 89
    },
    bio: "Imam al-Shafi'i was a highly influential early Islamic jurist who laid the foundations of Islamic jurisprudence. He founded the Shafi'i school of Islamic jurisprudence.",
    majorWorks: [
      "Al-Risala",
      "Al-Umm",
      "Kitab al-Majmu'"
    ],
    notableFor: [
      "Founder of Usul al-Fiqh (jurisprudence methodology)",
      "Founder of the Shafi'i madhab",
      "Harmonization of Quran and Sunnah"
    ],
    colorTheme: {
      primary: "from-green-500",
      secondary: "to-teal-600"
    }
  },
  {
    id: 9,
    name: "Imam Ahmad ibn Hanbal",
    arabicName: "أحمد بن حنبل",
    title: "Imam of Ahlus Sunnah",
    born: { hijri: 164, gregorian: 780 },
    died: { hijri: 241, gregorian: 855 },
    location: "Baghdad, Iraq",
    rarity: "legendary",
    level: 96,
    era: "Abbasid",
    madhab: "Hanbali",
    expertise: ["Hadith", "Fiqh", "Theology"],
    specialAbility: "Guardian of Authentic Hadith",
    stats: {
      knowledge: 99,
      influence: 94,
      piety: 98,
      works: 87,
      leadership: 85
    },
    bio: "Imam Ahmad ibn Hanbal was an Arab Muslim jurist and theologian, who founded the Hanbali school of Islamic jurisprudence. He is remembered for his steadfastness during the Mi'har (inquisition).",
    majorWorks: [
      "Musnad Ahmad ibn Hanbal",
      "Kitab al-Sunnah",
      "Al-'Ilal wa Ma'rifat al-Rijal"
    ],
    notableFor: [
      "Founder of the Hanbali madhab",
      "Compiler of one of largest Hadith collections",
      "Staunch defender of orthodox beliefs"
    ],
    colorTheme: {
      primary: "from-red-500",
      secondary: "to-pink-600"
    }
  },
  {
    id: 10,
    name: "Al-Bukhari",
    arabicName: "البخاري",
    title: "Master of Hadith Masters",
    born: { hijri: 194, gregorian: 810 },
    died: { hijri: 256, gregorian: 870 },
    location: "Bukhara, Uzbekistan",
    rarity: "legendary",
    level: 99,
    era: "Abbasid",
    madhab: "",
    expertise: ["Hadith Sciences", "Authentication"],
    specialAbility: "Compiler of Authentic Hadith",
    stats: {
      knowledge: 99,
      influence: 98,
      piety: 96,
      works: 98,
      leadership: 87
    },
    bio: "Al-Bukhari was a Persian Islamic scholar who collected and preserved authentic traditions of the Islamic prophet Muhammad. His compilation is considered the most authentic book after the Quran.",
    majorWorks: [
      "Sahih al-Bukhari",
      "Al-Adab al-Mufrad",
      "At-Tarikh al-Kabir"
    ],
    notableFor: [
      "Compiler of Sahih al-Bukhari",
      "Revolutionary hadith authentication methods",
      "Systematic categorization of prophetic traditions"
    ],
    colorTheme: {
      primary: "from-emerald-500",
      secondary: "to-green-600"
    }
  },
  {
    id: 11,
    name: "Muslim ibn al-Hajjaj",
    arabicName: "مسلم بن الحجاج",
    title: "Master of Truthful Narrators",
    born: { hijri: 206, gregorian: 821 },
    died: { hijri: 261, gregorian: 875 },
    location: "Nishapur, Iran",
    rarity: "legendary",
    level: 97,
    era: "Abbasid",
    madhab: "",
    expertise: ["Hadith Sciences", "Authentication"],
    specialAbility: "Compiler of Second Most Authentic Hadith",
    stats: {
      knowledge: 98,
      influence: 96,
      piety: 93,
      works: 97,
      leadership: 86
    },
    bio: "Muslim ibn al-Hajjaj was a Persian Muslim scholar, author, and compiler of the hadith collection known as Sahih Muslim. It is considered the second most authentic book after the Quran.",
    majorWorks: [
      "Sahih Muslim",
      "Al-Mashyaha"
    ],
    notableFor: [
      "Compiler of Sahih Muslim",
      "Strict criteria for hadith authentication",
      "Comprehensive hadith collection"
    ],
    colorTheme: {
      primary: "from-rose-500",
      secondary: "to-pink-600"
    }
  },
  {
    id: 12,
    name: "Al-Ghazali",
    arabicName: "الغزالي",
    title: "Hujjat al-Islam",
    born: { hijri: 450, gregorian: 1058 },
    died: { hijri: 505, gregorian: 1111 },
    location: "Tus, Iran",
    rarity: "legendary",
    level: 96,
    era: "Seljuk",
    madhab: "Shafi'i",
    expertise: ["Theology", "Philosophy", "Sufism"],
    specialAbility: "Reformer of Islamic Thought",
    stats: {
      knowledge: 98,
      influence: 98,
      piety: 97,
      works: 96,
      leadership: 88
    },
    bio: "Al-Ghazali was a Persian Islamic theologian, jurist, philosopher, and mystic. He is considered a key figure in the development of Islamic philosophy and Sufism.",
    majorWorks: [
      "Ihya Ulum al-Din",
      "Tahafut al-Falasifa",
      "Al-Mustasfa"
    ],
    notableFor: [
      "Great revitalizer of Islamic faith",
      "Bridge between theology and Sufism",
      "Critique of philosophers"
    ],
    colorTheme: {
      primary: "from-indigo-600",
      secondary: "to-purple-700"
    }
  },
  {
    id: 13,
    name: "Ibn Rushd",
    arabicName: "ابن رشد",
    title: "Averroes",
    born: { hijri: 520, gregorian: 1126 },
    died: { hijri: 595, gregorian: 1198 },
    location: "Cordoba, Spain",
    rarity: "epic",
    level: 90,
    era: "Almoravid",
    madhab: "Maliki",
    expertise: ["Philosophy", "Jurisprudence", "Medicine"],
    specialAbility: "Harmonizer of Faith and Reason",
    stats: {
      knowledge: 95,
      influence: 92,
      piety: 83,
      works: 93,
      leadership: 81
    },
    bio: "Ibn Rushd, often Latinized as Averroes, was a Muslim Andalusian polymath and jurist. He was a key figure in the Aristotelian tradition and influenced Christian scholasticism.",
    majorWorks: [
      "Fasl al-Maqal",
      "Tahafut al-Tahafut",
      "Kulliyat"
    ],
    notableFor: [
      "Defender of Aristotelian philosophy",
      "Influence on Western philosophy",
      "Integration of reason and revelation"
    ],
    colorTheme: {
      primary: "from-amber-500",
      secondary: "to-yellow-600"
    }
  },
  {
    id: 14,
    name: "Ibn al-Qayyim",
    arabicName: "ابن القيم",
    title: "Scholar & Reformer",
    born: { hijri: 691, gregorian: 1292 },
    died: { hijri: 751, gregorian: 1350 },
    location: "Damascus, Syria",
    rarity: "epic",
    level: 94,
    era: "Mamluk",
    madhab: "Hanbali",
    expertise: ["Fiqh", "Spirituality", "Writing"],
    specialAbility: "Heart Knowledge Master",
    stats: {
      knowledge: 96,
      influence: 92,
      piety: 96,
      works: 93,
      leadership: 85
    },
    bio: "Ibn al-Qayyim was an influential Islamic jurist, theologian, and mystic. He was one of the important followers of Ibn Taymiyyah.",
    majorWorks: [
      "Madarij al-Salikin",
      "I'lam al-Muwaqqi'in",
      "Tibb al-Nabawi"
    ],
    notableFor: [
      "Master of Islamic spirituality",
      "Expert in Islamic jurisprudence",
      "Prolific writer and scholar"
    ],
    colorTheme: {
      primary: "from-teal-500",
      secondary: "to-cyan-600"
    }
  },
  {
    id: 15,
    name: "Ibn Taymiyyah",
    arabicName: "ابن تيمية",
    title: "Mujaddid of the 7th Century",
    born: { hijri: 661, gregorian: 1263 },
    died: { hijri: 728, gregorian: 1328 },
    location: "Damascus, Syria",
    rarity: "legendary",
    level: 96,
    era: "Mamluk",
    madhab: "Hanbali",
    expertise: ["Jurisprudence", "Theology", "Hadith"],
    specialAbility: "Reviver of Authentic Islam",
    stats: {
      knowledge: 99,
      influence: 97,
      piety: 96,
      works: 97,
      leadership: 90
    },
    bio: "Ibn Taymiyyah was a medieval Islamic scholar, jurist, and theologian of the Hanbali school. He was known for his strict interpretation of Islamic texts and revival of salafism.",
    majorWorks: [
      "Majmu' al-Fatawa",
      "Al-'Aqidah al-Wasitiyyah",
      "Minhaj al-Sunnah"
    ],
    notableFor: [
      "Revival of pure Islamic teachings",
      "Critique of philosophical theology",
      "Extensive legal opinions and works"
    ],
    colorTheme: {
      primary: "from-blue-500",
      secondary: "to-cyan-600"
    }
  },
  {
    id: 16,
    name: "Jalal ad-Din Rumi",
    arabicName: "جلال الدين الرومي",
    title: "Sufi Poet & Scholar",
    born: { hijri: 604, gregorian: 1207 },
    died: { hijri: 672, gregorian: 1273 },
    location: "Konya, Turkey",
    rarity: "legendary",
    level: 98,
    era: "Seljuk",
    madhab: "Hanafi",
    expertise: ["Sufism", "Poetry", "Wisdom"],
    specialAbility: "Poet of Divine Love",
    stats: {
      knowledge: 97,
      influence: 99,
      piety: 99,
      works: 98,
      leadership: 92
    },
    bio: "Jalal ad-Din Rumi was a 13th-century Persian Sunni Muslim poet, jurist, Islamic scholar, theologian, and Sufi mystic. His influence transcends national and ethnic borders.",
    majorWorks: [
      "Masnavi",
      "Divan-e-Shams",
      "Fihi Ma Fihi"
    ],
    notableFor: [
      "Greatest mystical poet",
      "Founder of Mevlevi Order",
      "Symbol of tolerance and love"
    ],
    colorTheme: {
      primary: "from-pink-500",
      secondary: "to-purple-600"
    }
  },
  {
    id: 17,
    name: "Ibn Khaldun",
    arabicName: "ابن خلدون",
    title: "Founder of Social Sciences",
    born: { hijri: 732, gregorian: 1332 },
    died: { hijri: 808, gregorian: 1406 },
    location: "Tunis, Tunisia",
    rarity: "epic",
    level: 95,
    era: "Mamluk",
    madhab: "Maliki",
    expertise: ["History", "Sociology", "Economics"],
    specialAbility: "Pioneer of Social Sciences",
    stats: {
      knowledge: 98,
      influence: 95,
      piety: 88,
      works: 94,
      leadership: 91
    },
    bio: "Ibn Khaldun was an Arab historian, politician, demographer, economist, and philosopher. He is considered the father of sociology, historiography, demography, cultural history, and economics.",
    majorWorks: [
      "Muqaddimah",
      "Kitab al-'Ibar",
      "Tarikh Ibn Khaldun"
    ],
    notableFor: [
      "Founder of social sciences",
      "Cyclical theory of civilizations",
      "Historical methodology and critique"
    ],
    colorTheme: {
      primary: "from-orange-500",
      secondary: "to-red-500"
    }
  },
  {
    id: 18,
    name: "Imam al-Suyuti",
    arabicName: "السيوطي",
    title: "Prolific Scholar",
    born: { hijri: 849, gregorian: 1445 },
    died: { hijri: 911, gregorian: 1505 },
    location: "Cairo, Egypt",
    rarity: "epic",
    level: 96,
    era: "Mamluk",
    madhab: "Shafi'i",
    expertise: ["Writing", "Hadith", "Versatility"],
    specialAbility: "Master of All Islamic Sciences",
    stats: {
      knowledge: 99,
      influence: 95,
      piety: 92,
      works: 100,
      leadership: 89
    },
    bio: "Imam al-Suyuti was an Egyptian Muslim jurist, exegete, traditionalist, and biographer. He was particularly noted for his versatility in Islamic studies.",
    majorWorks: [
      "Al-Itqan fi 'Ulum al-Quran",
      "Al-Jami' al-Saghir",
      "Tabaqat al-Mufassirin"
    ],
    notableFor: [
      "Most prolific Islamic writer",
      "Master of Quranic sciences",
      "Expert in multiple fields"
    ],
    colorTheme: {
      primary: "from-lime-500",
      secondary: "to-green-500"
    }
  },
  {
    id: 19,
    name: "Shah Waliullah Dehlawi",
    arabicName: "شاه ولی اللہ دہلوی",
    title: "Indian Reformer",
    born: { hijri: 1114, gregorian: 1703 },
    died: { hijri: 1176, gregorian: 1762 },
    location: "Delhi, India",
    rarity: "epic",
    level: 93,
    era: "Mughal",
    madhab: "Hanafi",
    expertise: ["Hadith", "Reform", "Balance"],
    specialAbility: "Reviver of the 12th Century",
    stats: {
      knowledge: 95,
      influence: 94,
      piety: 93,
      works: 90,
      leadership: 88
    },
    bio: "Shah Waliullah Dehlawi was an Islamic scholar, theologian, and reformer who worked to revive Islam in the Indian subcontinent.",
    majorWorks: [
      "Hujjat Allah al-Baligha",
      "Fayd al-Bari",
      "Izalat al-Khafa"
    ],
    notableFor: [
      "Revival of Islamic teachings in India",
      "Translation of Quran to Persian",
      "Harmony between Sufism and Sharia"
    ],
    colorTheme: {
      primary: "from-amber-600",
      secondary: "to-yellow-500"
    }
  },
  {
    id: 20,
    name: "Ibn Abidin",
    arabicName: "ابن عابدين",
    title: "Hanafi Jurist",
    born: { hijri: 1208, gregorian: 1784 },
    died: { hijri: 1252, gregorian: 1836 },
    location: "Damascus, Syria",
    rarity: "epic",
    level: 94,
    era: "Ottoman",
    madhab: "Hanafi",
    expertise: ["Fiqh", "Legal Writing", "Precision"],
    specialAbility: "Master of Hanafi Jurisprudence",
    stats: {
      knowledge: 98,
      influence: 94,
      piety: 91,
      works: 95,
      leadership: 88
    },
    bio: "Ibn Abidin was a prominent Ottoman Islamic scholar of the Hanafi school of jurisprudence. He is known as the renewer (mujaddid) of the 13th Islamic century.",
    majorWorks: [
      "Radd al-Muhtar",
      "Nail al-Aytar",
      "Al-Luqat al-Saniyya"
    ],
    notableFor: [
      "Greatest Hanafi jurist after al-Shami",
      "Comprehensive legal commentary",
      "Expert in Islamic jurisprudence"
    ],
    colorTheme: {
      primary: "from-gray-500",
      secondary: "to-slate-600"
    }
  },
  // ====== NEW 50 SCHOLARS ======
  {
    id: 21,
    name: "Bilal ibn Rabah",
    arabicName: "بلال بن رباح",
    title: "First Muezzin",
    born: { hijri: -43, gregorian: 580 },
    died: { hijri: 20, gregorian: 640 },
    location: "Mecca, Saudi Arabia",
    rarity: "epic",
    level: 92,
    era: "Sahaba",
    madhab: "",
    expertise: ["Faith", "Perseverance", "Devotion"],
    specialAbility: "Voice of Islam",
    stats: {
      knowledge: 85,
      influence: 92,
      piety: 94,
      works: 80,
      leadership: 88
    },
    bio: "Bilal ibn Rabah was one of the most trusted companions of Prophet Muhammad. An Ethiopian slave who was freed by Abu Bakr, he became the first muezzin in Islam.",
    majorWorks: [
      "Established the Adhan tradition",
      "Participated in all major battles",
      "Treasury management in Medina"
    ],
    notableFor: [
      "First muezzin in Islam",
      "Endured severe torture for his faith",
      "Symbol of equality in Islam"
    ],
    colorTheme: {
      primary: "from-amber-500",
      secondary: "to-orange-600"
    }
  },
  {
    id: 22,
    name: "Salman al-Farsi",
    arabicName: "سلمان الفارسي",
    title: "Persian Companion",
    born: { hijri: -55, gregorian: 568 },
    died: { hijri: 33, gregorian: 653 },
    location: "Ctesiphon, Persia",
    rarity: "epic",
    level: 91,
    era: "Sahaba",
    madhab: "",
    expertise: ["Wisdom", "Strategy", "Loyalty"],
    specialAbility: "Seeker of Truth",
    stats: {
      knowledge: 88,
      influence: 87,
      piety: 91,
      works: 82,
      leadership: 85
    },
    bio: "Salman al-Farsi was a companion of Prophet Muhammad who traveled from Zoroastrian Persia seeking the truth. He suggested the trench strategy in the Battle of the Trench.",
    majorWorks: [
      "Strategy of the Trench",
      "Governor of Ctesiphon",
      "Translation efforts"
    ],
    notableFor: [
      "Journey from Persia seeking truth",
      "Suggested the trench defense strategy",
      "Bridge between Persian and Arab cultures"
    ],
    colorTheme: {
      primary: "from-cyan-500",
      secondary: "to-blue-600"
    }
  },
  {
    id: 23,
    name: "Abdullah ibn Abbas",
    arabicName: "عبد الله بن عباس",
    title: "Interpreter of Quran",
    born: { hijri: -3, gregorian: 619 },
    died: { hijri: 68, gregorian: 687 },
    location: "Mecca, Saudi Arabia",
    rarity: "legendary",
    level: 95,
    era: "Sahaba",
    madhab: "",
    expertise: ["Tafsir", "Knowledge", "Insight"],
    specialAbility: "Ocean of Knowledge",
    stats: {
      knowledge: 95,
      influence: 93,
      piety: 90,
      works: 91,
      leadership: 87
    },
    bio: "Abdullah ibn Abbas was a cousin of Prophet Muhammad and one of the greatest scholars among the Companions. He is known as 'Hibr al-Ummah' (the scholar of the nation).",
    majorWorks: [
      "Tafsir Ibn Abbas",
      "Established Tafsir methodology",
      "Hadith narrations"
    ],
    notableFor: [
      "Greatest interpreter of Quran among Sahaba",
      "Prophet prayed for his understanding",
      "Founder of Quranic exegesis"
    ],
    colorTheme: {
      primary: "from-emerald-500",
      secondary: "to-teal-600"
    }
  },
  {
    id: 24,
    name: "Aisha bint Abi Bakr",
    arabicName: "عائشة بنت أبي بكر",
    title: "Mother of the Believers",
    born: { hijri: -9, gregorian: 613 },
    died: { hijri: 58, gregorian: 678 },
    location: "Mecca, Saudi Arabia",
    rarity: "legendary",
    level: 96,
    era: "Sahaba",
    madhab: "",
    expertise: ["Hadith", "Intelligence", "Teaching"],
    specialAbility: "Scholar of the Ummah",
    stats: {
      knowledge: 94,
      influence: 95,
      piety: 92,
      works: 91,
      leadership: 89
    },
    bio: "Aisha bint Abi Bakr was the wife of Prophet Muhammad and daughter of Abu Bakr. She was one of the most knowledgeable companions and a major source of hadith.",
    majorWorks: [
      "Over 2,200 hadith narrations",
      "Correction of companions' errors",
      "Teaching in Medina"
    ],
    notableFor: [
      "Greatest female scholar in Islam",
      "Major hadith narrator",
      "Expert in fiqh and medicine"
    ],
    colorTheme: {
      primary: "from-rose-500",
      secondary: "to-pink-600"
    }
  },
  {
    id: 25,
    name: "Abdullah ibn Umar",
    arabicName: "عبد الله بن عمر",
    title: "Hadith Narrator",
    born: { hijri: -10, gregorian: 614 },
    died: { hijri: 73, gregorian: 693 },
    location: "Mecca, Saudi Arabia",
    rarity: "epic",
    level: 92,
    era: "Sahaba",
    madhab: "",
    expertise: ["Piety", "Precision", "Devotion"],
    specialAbility: "Follower of the Sunnah",
    stats: {
      knowledge: 89,
      influence: 90,
      piety: 92,
      works: 88,
      leadership: 84
    },
    bio: "Abdullah ibn Umar was a prominent companion and the son of Caliph Umar. He was known for his strict adherence to the Sunnah and narrated over 2,600 hadiths.",
    majorWorks: [
      "2,630 hadith narrations",
      "Following Sunnah meticulously",
      "Teaching the next generation"
    ],
    notableFor: [
      "Most meticulous follower of Sunnah",
      "Major hadith narrator",
      "Known for his piety"
    ],
    colorTheme: {
      primary: "from-blue-500",
      secondary: "to-indigo-600"
    }
  },
  {
    id: 26,
    name: "Abdullah ibn Mas'ud",
    arabicName: "عبد الله بن مسعود",
    title: "Quran Reciter",
    born: { hijri: -32, gregorian: 594 },
    died: { hijri: 32, gregorian: 653 },
    location: "Mecca, Saudi Arabia",
    rarity: "epic",
    level: 93,
    era: "Sahaba",
    madhab: "",
    expertise: ["Quranic Knowledge", "Recitation", "Teaching"],
    specialAbility: "Guardian of Quranic Recitation",
    stats: {
      knowledge: 93,
      influence: 89,
      piety: 91,
      works: 88,
      leadership: 86
    },
    bio: "Abdullah ibn Mas'ud was among the first to embrace Islam and was known for his beautiful Quran recitation. The Prophet said to learn the Quran from four people, and Ibn Mas'ud was first.",
    majorWorks: [
      "Quranic codex",
      "Hadith narrations",
      "Teaching Quran in Kufa"
    ],
    notableFor: [
      "One of the four from whom to learn Quran",
      "First to recite Quran publicly in Mecca",
      "Expert in Quranic sciences"
    ],
    colorTheme: {
      primary: "from-violet-500",
      secondary: "to-purple-600"
    }
  },
  {
    id: 27,
    name: "Abu Huraira",
    arabicName: "أبو هريرة",
    title: "Greatest Hadith Narrator",
    born: { hijri: -21, gregorian: 603 },
    died: { hijri: 59, gregorian: 681 },
    location: "Bahrain",
    rarity: "legendary",
    level: 95,
    era: "Sahaba",
    madhab: "",
    expertise: ["Memory", "Hadith", "Dedication"],
    specialAbility: "Vessel of Prophetic Traditions",
    stats: {
      knowledge: 91,
      influence: 96,
      piety: 90,
      works: 95,
      leadership: 83
    },
    bio: "Abu Huraira was a companion known for his incredible memory. He narrated more hadiths than any other companion, with over 5,300 traditions attributed to him.",
    majorWorks: [
      "5,374 hadith narrations",
      "Teaching in Medina",
      "Preservation of Sunnah"
    ],
    notableFor: [
      "Most prolific hadith narrator",
      "Exceptional memory blessed by Prophet",
      "Dedicated his life to preserving hadith"
    ],
    colorTheme: {
      primary: "from-yellow-500",
      secondary: "to-amber-600"
    }
  },
  {
    id: 28,
    name: "Mu'adh ibn Jabal",
    arabicName: "معاذ بن جبل",
    title: "Master of Halal & Haram",
    born: { hijri: -20, gregorian: 603 },
    died: { hijri: 18, gregorian: 639 },
    location: "Medina, Saudi Arabia",
    rarity: "epic",
    level: 91,
    era: "Sahaba",
    madhab: "",
    expertise: ["Fiqh", "Knowledge", "Judgment"],
    specialAbility: "Most Knowledgeable in Halal and Haram",
    stats: {
      knowledge: 89,
      influence: 88,
      piety: 90,
      works: 85,
      leadership: 87
    },
    bio: "Mu'adh ibn Jabal was a companion praised by the Prophet as the most knowledgeable of his ummah in matters of halal and haram. He was sent to Yemen as a judge.",
    majorWorks: [
      "Judge in Yemen",
      "Teaching methodology",
      "Hadith narrations"
    ],
    notableFor: [
      "Expert in legal rulings",
      "Sent to Yemen by Prophet",
      "Developed ijtihad methodology"
    ],
    colorTheme: {
      primary: "from-teal-500",
      secondary: "to-green-600"
    }
  },
  {
    id: 29,
    name: "Hasan al-Basri",
    arabicName: "الحسن البصري",
    title: "Ascetic Scholar",
    born: { hijri: 21, gregorian: 642 },
    died: { hijri: 110, gregorian: 728 },
    location: "Basra, Iraq",
    rarity: "epic",
    level: 93,
    era: "Tabi'un",
    madhab: "",
    expertise: ["Piety", "Eloquence", "Wisdom"],
    specialAbility: "Master of Zuhd (Asceticism)",
    stats: {
      knowledge: 91,
      influence: 91,
      piety: 93,
      works: 88,
      leadership: 89
    },
    bio: "Hasan al-Basri was one of the most famous Tabi'un, known for his piety, eloquent sermons, and asceticism. He was a key figure in early Islamic spirituality.",
    majorWorks: [
      "Sermons on asceticism",
      "Letters to Caliph Umar II",
      "Teaching in Basra"
    ],
    notableFor: [
      "Greatest Tabi'i scholar",
      "Pioneer of Islamic spirituality",
      "Known for his weeping in worship"
    ],
    colorTheme: {
      primary: "from-slate-500",
      secondary: "to-gray-600"
    }
  },
  {
    id: 30,
    name: "Umar ibn Abdul Aziz",
    arabicName: "عمر بن عبد العزيز",
    title: "Fifth Rightly Guided Caliph",
    born: { hijri: 63, gregorian: 682 },
    died: { hijri: 101, gregorian: 720 },
    location: "Medina, Saudi Arabia",
    rarity: "legendary",
    level: 94,
    era: "Umayyad",
    madhab: "",
    expertise: ["Justice", "Piety", "Reform"],
    specialAbility: "Restorer of Justice",
    stats: {
      knowledge: 90,
      influence: 93,
      piety: 95,
      works: 91,
      leadership: 94
    },
    bio: "Umar ibn Abdul Aziz was an Umayyad caliph known for his piety and justice. He is considered by many scholars as the fifth rightly guided caliph.",
    majorWorks: [
      "Reformation of Umayyad rule",
      "Codification of hadith",
      "Just taxation system"
    ],
    notableFor: [
      "Restored justice to the caliphate",
      "Ordered official hadith compilation",
      "Lived simply despite being caliph"
    ],
    colorTheme: {
      primary: "from-emerald-600",
      secondary: "to-green-700"
    }
  },
  {
    id: 31,
    name: "Abu Dawud",
    arabicName: "أبو داود",
    title: "Sunan Compiler",
    born: { hijri: 202, gregorian: 817 },
    died: { hijri: 275, gregorian: 889 },
    location: "Sijistan, Iran",
    rarity: "epic",
    level: 91,
    era: "Abbasid",
    madhab: "",
    expertise: ["Hadith Science", "Precision", "Dedication"],
    specialAbility: "Compiler of Sunan",
    stats: {
      knowledge: 91,
      influence: 89,
      piety: 89,
      works: 90,
      leadership: 84
    },
    bio: "Abu Dawud was a Persian Islamic scholar who compiled one of the six canonical hadith collections, Sunan Abi Dawud, focusing on hadiths related to legal rulings.",
    majorWorks: [
      "Sunan Abi Dawud",
      "Risalah to Makkah",
      "Kitab al-Marasil"
    ],
    notableFor: [
      "Third of the six major hadith collections",
      "Focus on legal hadiths",
      "Collected 500,000 hadiths, selected 4,800"
    ],
    colorTheme: {
      primary: "from-indigo-500",
      secondary: "to-blue-600"
    }
  },
  {
    id: 32,
    name: "Al-Tirmidhi",
    arabicName: "الترمذي",
    title: "Sunan Compiler",
    born: { hijri: 209, gregorian: 824 },
    died: { hijri: 279, gregorian: 892 },
    location: "Termez, Uzbekistan",
    rarity: "epic",
    level: 90,
    era: "Abbasid",
    madhab: "",
    expertise: ["Hadith", "Classification", "Writing"],
    specialAbility: "Master of Hadith Classification",
    stats: {
      knowledge: 90,
      influence: 88,
      piety: 89,
      works: 91,
      leadership: 82
    },
    bio: "Al-Tirmidhi was a Persian Islamic scholar and collector of hadith. His Jami' al-Tirmidhi is one of the six major hadith collections and unique for its grading system.",
    majorWorks: [
      "Jami' al-Tirmidhi",
      "Al-Shama'il al-Muhammadiyya",
      "Kitab al-'Ilal"
    ],
    notableFor: [
      "Pioneered hadith grading system",
      "Wrote about the Prophet's characteristics",
      "Student of Bukhari"
    ],
    colorTheme: {
      primary: "from-purple-500",
      secondary: "to-violet-600"
    }
  },
  {
    id: 33,
    name: "Al-Nasa'i",
    arabicName: "النسائي",
    title: "Sunan Compiler",
    born: { hijri: 214, gregorian: 829 },
    died: { hijri: 303, gregorian: 915 },
    location: "Nasa, Turkmenistan",
    rarity: "epic",
    level: 90,
    era: "Abbasid",
    madhab: "",
    expertise: ["Hadith", "Strictness", "Scholarship"],
    specialAbility: "Strictest Hadith Critic",
    stats: {
      knowledge: 90,
      influence: 87,
      piety: 92,
      works: 89,
      leadership: 81
    },
    bio: "Al-Nasa'i was a Persian Islamic scholar known for his strict criteria in accepting hadiths. His Sunan al-Nasa'i is considered one of the most authentic collections.",
    majorWorks: [
      "Sunan al-Nasa'i (al-Kubra & al-Sughra)",
      "Kitab al-Du'afa",
      "Khasa'is Ali"
    ],
    notableFor: [
      "Strictest conditions among six collectors",
      "His collection closest to Bukhari/Muslim",
      "Known for his devotion"
    ],
    colorTheme: {
      primary: "from-sky-500",
      secondary: "to-cyan-600"
    }
  },
  {
    id: 34,
    name: "Ibn Majah",
    arabicName: "ابن ماجه",
    title: "Sunan Compiler",
    born: { hijri: 209, gregorian: 824 },
    died: { hijri: 273, gregorian: 887 },
    location: "Qazvin, Iran",
    rarity: "rare",
    level: 88,
    era: "Abbasid",
    madhab: "",
    expertise: ["Hadith", "Collection", "Perseverance"],
    specialAbility: "Completer of the Six Books",
    stats: {
      knowledge: 88,
      influence: 85,
      piety: 89,
      works: 87,
      leadership: 80
    },
    bio: "Ibn Majah was a medieval Islamic scholar who compiled Sunan Ibn Majah, one of the six major hadith collections. His work completes the canonical six books.",
    majorWorks: [
      "Sunan Ibn Majah",
      "Tafsir Ibn Majah",
      "Tarikh"
    ],
    notableFor: [
      "Sixth of the canonical hadith collections",
      "Contains unique hadiths",
      "Traveled widely to collect hadith"
    ],
    colorTheme: {
      primary: "from-orange-500",
      secondary: "to-red-600"
    }
  },
  {
    id: 35,
    name: "Abu Yusuf",
    arabicName: "أبو يوسف",
    title: "Chief Qadi of Baghdad",
    born: { hijri: 113, gregorian: 731 },
    died: { hijri: 182, gregorian: 798 },
    location: "Kufa, Iraq",
    rarity: "epic",
    level: 91,
    era: "Abbasid",
    madhab: "Hanafi",
    expertise: ["Fiqh", "Judgment", "Administration"],
    specialAbility: "First Grand Qadi",
    stats: {
      knowledge: 90,
      influence: 91,
      piety: 87,
      works: 88,
      leadership: 90
    },
    bio: "Abu Yusuf was the most prominent student of Abu Hanifa and became the first Qadi al-Qudat (Chief Judge) of the Abbasid Caliphate. He spread the Hanafi school.",
    majorWorks: [
      "Kitab al-Kharaj",
      "Kitab al-Athar",
      "Al-Radd 'ala Siyar al-Awza'i"
    ],
    notableFor: [
      "First Chief Judge in Islamic history",
      "Spread Hanafi madhab through judiciary",
      "Key figure in Islamic taxation"
    ],
    colorTheme: {
      primary: "from-amber-500",
      secondary: "to-yellow-600"
    }
  },
  {
    id: 36,
    name: "Muhammad al-Shaybani",
    arabicName: "محمد بن الحسن الشيباني",
    title: "Hanafi Scholar",
    born: { hijri: 132, gregorian: 749 },
    died: { hijri: 189, gregorian: 805 },
    location: "Wasit, Iraq",
    rarity: "epic",
    level: 90,
    era: "Abbasid",
    madhab: "Hanafi",
    expertise: ["Fiqh", "Writing", "Logic"],
    specialAbility: "Codifier of Hanafi Fiqh",
    stats: {
      knowledge: 89,
      influence: 88,
      piety: 88,
      works: 91,
      leadership: 85
    },
    bio: "Muhammad al-Shaybani was a key student of Abu Hanifa and Malik. He systematically wrote down the Hanafi school's legal opinions, making them accessible.",
    majorWorks: [
      "Al-Mabsut",
      "Al-Jami' al-Saghir",
      "Kitab al-Asl"
    ],
    notableFor: [
      "Preserved Abu Hanifa's teachings in writing",
      "Teacher of Imam al-Shafi'i",
      "Father of international law"
    ],
    colorTheme: {
      primary: "from-teal-500",
      secondary: "to-emerald-600"
    }
  },
  {
    id: 37,
    name: "Al-Tahawi",
    arabicName: "الطحاوي",
    title: "Creed Scholar",
    born: { hijri: 239, gregorian: 843 },
    died: { hijri: 321, gregorian: 933 },
    location: "Tahawi, Egypt",
    rarity: "epic",
    level: 91,
    era: "Abbasid",
    madhab: "Hanafi",
    expertise: ["Theology", "Hadith", "Precision"],
    specialAbility: "Definer of Sunni Creed",
    stats: {
      knowledge: 90,
      influence: 89,
      piety: 91,
      works: 90,
      leadership: 85
    },
    bio: "Al-Tahawi was an Egyptian Islamic scholar known for his work on Islamic creed. His Aqeedah al-Tahawiyyah remains a foundational text on Sunni beliefs.",
    majorWorks: [
      "Aqeedah al-Tahawiyyah",
      "Sharh Ma'ani al-Athar",
      "Mushkil al-Athar"
    ],
    notableFor: [
      "Defining statement of Sunni creed",
      "Reconciled seemingly contradictory hadiths",
      "Started as Shafi'i, became Hanafi"
    ],
    colorTheme: {
      primary: "from-indigo-500",
      secondary: "to-purple-600"
    }
  },
  {
    id: 38,
    name: "Ibn Hibban",
    arabicName: "ابن حبان",
    title: "Hadith Critic",
    born: { hijri: 270, gregorian: 884 },
    died: { hijri: 354, gregorian: 965 },
    location: "Bust, Afghanistan",
    rarity: "epic",
    level: 90,
    era: "Abbasid",
    madhab: "Shafi'i",
    expertise: ["Hadith Criticism", "Analysis", "Memory"],
    specialAbility: "Authenticator of Traditions",
    stats: {
      knowledge: 91,
      influence: 87,
      piety: 89,
      works: 90,
      leadership: 83
    },
    bio: "Ibn Hibban was a Persian Islamic scholar known for his hadith collection Sahih Ibn Hibban and works on narrator criticism. He was a judge in Samarkand.",
    majorWorks: [
      "Sahih Ibn Hibban",
      "Al-Thiqat",
      "Al-Majruhin"
    ],
    notableFor: [
      "Important hadith collection",
      "Works on reliable and weak narrators",
      "Systematic biographical methodology"
    ],
    colorTheme: {
      primary: "from-rose-500",
      secondary: "to-pink-600"
    }
  },
  {
    id: 39,
    name: "Al-Kindi",
    arabicName: "الكندي",
    title: "Philosopher of the Arabs",
    born: { hijri: 185, gregorian: 801 },
    died: { hijri: 260, gregorian: 873 },
    location: "Kufa, Iraq",
    rarity: "rare",
    level: 89,
    era: "Abbasid",
    madhab: "",
    expertise: ["Philosophy", "Mathematics", "Science"],
    specialAbility: "Pioneer of Islamic Philosophy",
    stats: {
      knowledge: 89,
      influence: 86,
      piety: 84,
      works: 88,
      leadership: 80
    },
    bio: "Al-Kindi was an Arab Muslim philosopher, mathematician, and scientist known as the 'Philosopher of the Arabs.' He introduced Greek philosophy to the Islamic world.",
    majorWorks: [
      "On First Philosophy",
      "Works on mathematics",
      "Treatises on music"
    ],
    notableFor: [
      "First major Muslim philosopher",
      "Introduced Greek philosophy to Muslims",
      "Contributions to cryptography"
    ],
    colorTheme: {
      primary: "from-cyan-500",
      secondary: "to-blue-600"
    }
  },
  {
    id: 40,
    name: "Ibn Sina (Avicenna)",
    arabicName: "ابن سينا",
    title: "Universal Genius",
    born: { hijri: 370, gregorian: 980 },
    died: { hijri: 428, gregorian: 1037 },
    location: "Bukhara, Uzbekistan",
    rarity: "legendary",
    level: 94,
    era: "Samanid",
    madhab: "",
    expertise: ["Medicine", "Philosophy", "Science"],
    specialAbility: "Prince of Physicians",
    stats: {
      knowledge: 94,
      influence: 94,
      piety: 85,
      works: 95,
      leadership: 88
    },
    bio: "Ibn Sina was a Persian polymath regarded as one of the most significant physicians and philosophers of the Islamic Golden Age. His Canon of Medicine was a standard medical text.",
    majorWorks: [
      "The Canon of Medicine",
      "The Book of Healing",
      "Kitab al-Najat"
    ],
    notableFor: [
      "Father of early modern medicine",
      "Canon used in Europe for 500 years",
      "Pioneered clinical trials"
    ],
    colorTheme: {
      primary: "from-emerald-500",
      secondary: "to-teal-600"
    }
  },
  {
    id: 41,
    name: "Al-Biruni",
    arabicName: "البيروني",
    title: "Polymath",
    born: { hijri: 362, gregorian: 973 },
    died: { hijri: 440, gregorian: 1048 },
    location: "Kath, Khwarezm",
    rarity: "epic",
    level: 91,
    era: "Ghaznavid",
    madhab: "",
    expertise: ["Astronomy", "Mathematics", "Geography"],
    specialAbility: "Master of Sciences",
    stats: {
      knowledge: 91,
      influence: 88,
      piety: 87,
      works: 92,
      leadership: 83
    },
    bio: "Al-Biruni was a Persian scholar and polymath who made contributions to mathematics, astronomy, and geography. He studied Indian culture extensively.",
    majorWorks: [
      "Tarikh al-Hind",
      "Al-Qanun al-Mas'udi",
      "Kitab al-Tafhim"
    ],
    notableFor: [
      "Calculated Earth's circumference accurately",
      "Pioneer of comparative religion",
      "First anthropologist"
    ],
    colorTheme: {
      primary: "from-violet-500",
      secondary: "to-purple-600"
    }
  },
  {
    id: 42,
    name: "Ibn al-Haytham",
    arabicName: "ابن الهيثم",
    title: "Father of Optics",
    born: { hijri: 354, gregorian: 965 },
    died: { hijri: 430, gregorian: 1040 },
    location: "Basra, Iraq",
    rarity: "epic",
    level: 93,
    era: "Fatimid",
    madhab: "",
    expertise: ["Science", "Innovation", "Experimentation"],
    specialAbility: "Pioneer of Scientific Method",
    stats: {
      knowledge: 93,
      influence: 90,
      piety: 88,
      works: 91,
      leadership: 82
    },
    bio: "Ibn al-Haytham was an Arab mathematician and physicist who made significant contributions to optics. He is credited with pioneering the scientific method.",
    majorWorks: [
      "Book of Optics",
      "Doubts on Ptolemy",
      "On the Configuration of the World"
    ],
    notableFor: [
      "Father of modern optics",
      "Pioneer of scientific method",
      "Explained vision correctly"
    ],
    colorTheme: {
      primary: "from-blue-500",
      secondary: "to-indigo-600"
    }
  },
  {
    id: 43,
    name: "Al-Khwarizmi",
    arabicName: "الخوارزمي",
    title: "Father of Algebra",
    born: { hijri: 164, gregorian: 780 },
    died: { hijri: 235, gregorian: 850 },
    location: "Khwarezm, Uzbekistan",
    rarity: "legendary",
    level: 94,
    era: "Abbasid",
    madhab: "",
    expertise: ["Mathematics", "Innovation", "Geography"],
    specialAbility: "Founder of Algebra",
    stats: {
      knowledge: 94,
      influence: 93,
      piety: 86,
      works: 92,
      leadership: 85
    },
    bio: "Al-Khwarizmi was a Persian mathematician whose works on algebra and arithmetic introduced Hindu-Arabic numerals to the West. The word 'algorithm' derives from his name.",
    majorWorks: [
      "Al-Kitab al-Mukhtasar",
      "Zij al-Sindhind",
      "Kitab Surat al-Ard"
    ],
    notableFor: [
      "Father of algebra",
      "Algorithm named after him",
      "Introduced Hindu-Arabic numerals to West"
    ],
    colorTheme: {
      primary: "from-yellow-500",
      secondary: "to-orange-600"
    }
  },
  {
    id: 44,
    name: "Al-Razi (Rhazes)",
    arabicName: "الرازي",
    title: "Medical Pioneer",
    born: { hijri: 240, gregorian: 854 },
    died: { hijri: 313, gregorian: 925 },
    location: "Ray, Iran",
    rarity: "epic",
    level: 92,
    era: "Abbasid",
    madhab: "",
    expertise: ["Medicine", "Chemistry", "Innovation"],
    specialAbility: "Master of Clinical Medicine",
    stats: {
      knowledge: 92,
      influence: 89,
      piety: 85,
      works: 91,
      leadership: 84
    },
    bio: "Al-Razi was a Persian physician and alchemist who made fundamental contributions to medicine and chemistry. He discovered sulfuric acid and differentiated smallpox from measles.",
    majorWorks: [
      "Al-Hawi (The Comprehensive Book)",
      "Kitab al-Mansuri",
      "On Smallpox and Measles"
    ],
    notableFor: [
      "Discovered sulfuric acid",
      "First to differentiate smallpox and measles",
      "Pioneer of experimental medicine"
    ],
    colorTheme: {
      primary: "from-green-500",
      secondary: "to-emerald-600"
    }
  },
  {
    id: 45,
    name: "Al-Hakim al-Nishapuri",
    arabicName: "الحاكم النيسابوري",
    title: "Hadith Scholar",
    born: { hijri: 321, gregorian: 933 },
    died: { hijri: 405, gregorian: 1014 },
    location: "Nishapur, Iran",
    rarity: "epic",
    level: 90,
    era: "Samanid",
    madhab: "Shafi'i",
    expertise: ["Hadith", "Criticism", "Collection"],
    specialAbility: "Defender of Authentic Hadith",
    stats: {
      knowledge: 90,
      influence: 87,
      piety: 91,
      works: 89,
      leadership: 83
    },
    bio: "Al-Hakim al-Nishapuri was a Persian Sunni scholar known for his hadith collection Al-Mustadrak, which contains hadiths he considered authentic but not in Bukhari or Muslim.",
    majorWorks: [
      "Al-Mustadrak ala al-Sahihayn",
      "Ma'rifat Ulum al-Hadith",
      "Tarikh Nishapur"
    ],
    notableFor: [
      "Major hadith collection beyond Six Books",
      "Pioneer in hadith sciences methodology",
      "Extensive biographical work"
    ],
    colorTheme: {
      primary: "from-slate-500",
      secondary: "to-gray-600"
    }
  },
  {
    id: 46,
    name: "Al-Bayhaqi",
    arabicName: "البيهقي",
    title: "Hadith Compiler",
    born: { hijri: 384, gregorian: 994 },
    died: { hijri: 458, gregorian: 1066 },
    location: "Bayhaq, Iran",
    rarity: "epic",
    level: 90,
    era: "Seljuk",
    madhab: "Shafi'i",
    expertise: ["Hadith", "Fiqh", "Organization"],
    specialAbility: "Systematic Hadith Compiler",
    stats: {
      knowledge: 90,
      influence: 88,
      piety: 90,
      works: 92,
      leadership: 84
    },
    bio: "Al-Bayhaqi was a Persian Islamic scholar known for his comprehensive hadith works. His Sunan al-Kubra is one of the largest hadith collections ever compiled.",
    majorWorks: [
      "Sunan al-Kubra",
      "Shu'ab al-Iman",
      "Ma'rifat al-Sunan wal-Athar"
    ],
    notableFor: [
      "One of largest hadith compilations",
      "Documented Shafi'i school evidence",
      "Systematic organization of fiqh hadiths"
    ],
    colorTheme: {
      primary: "from-teal-500",
      secondary: "to-cyan-600"
    }
  },
  {
    id: 47,
    name: "Al-Nawawi",
    arabicName: "النووي",
    title: "Shafi'i Scholar",
    born: { hijri: 631, gregorian: 1233 },
    died: { hijri: 676, gregorian: 1277 },
    location: "Nawa, Syria",
    rarity: "legendary",
    level: 95,
    era: "Mamluk",
    madhab: "Shafi'i",
    expertise: ["Hadith", "Fiqh", "Writing"],
    specialAbility: "Master of Hadith Commentary",
    stats: {
      knowledge: 92,
      influence: 94,
      piety: 95,
      works: 96,
      leadership: 86
    },
    bio: "Al-Nawawi was a Syrian Islamic scholar considered one of the most important figures in Shafi'i fiqh. His commentary on Sahih Muslim and 40 Hadith collection are widely studied.",
    majorWorks: [
      "Sharh Sahih Muslim",
      "Riyadh al-Salihin",
      "Al-Arba'in al-Nawawiyyah"
    ],
    notableFor: [
      "40 Hadith of Nawawi memorized globally",
      "Best commentary on Sahih Muslim",
      "Despite short life, incredibly prolific"
    ],
    colorTheme: {
      primary: "from-green-500",
      secondary: "to-emerald-600"
    }
  },
  {
    id: 48,
    name: "Ibn Hajar al-Asqalani",
    arabicName: "ابن حجر العسقلاني",
    title: "Hadith Commentator",
    born: { hijri: 773, gregorian: 1372 },
    died: { hijri: 852, gregorian: 1449 },
    location: "Cairo, Egypt",
    rarity: "legendary",
    level: 96,
    era: "Mamluk",
    madhab: "Shafi'i",
    expertise: ["Hadith Commentary", "Memory", "Writing"],
    specialAbility: "Commander of the Faithful in Hadith",
    stats: {
      knowledge: 94,
      influence: 95,
      piety: 92,
      works: 97,
      leadership: 88
    },
    bio: "Ibn Hajar al-Asqalani was an Egyptian scholar who is considered the greatest hadith commentator. His Fath al-Bari commentary on Sahih Bukhari is unparalleled.",
    majorWorks: [
      "Fath al-Bari",
      "Tahdhib al-Tahdhib",
      "Bulugh al-Maram"
    ],
    notableFor: [
      "Greatest commentary on Bukhari",
      "Chief Judge of Egypt",
      "Commander of the Faithful in Hadith"
    ],
    colorTheme: {
      primary: "from-amber-500",
      secondary: "to-yellow-600"
    }
  },
  {
    id: 49,
    name: "Al-Dhahabi",
    arabicName: "الذهبي",
    title: "Historian & Hadith Scholar",
    born: { hijri: 673, gregorian: 1274 },
    died: { hijri: 748, gregorian: 1348 },
    location: "Damascus, Syria",
    rarity: "epic",
    level: 93,
    era: "Mamluk",
    madhab: "Shafi'i",
    expertise: ["History", "Biography", "Hadith"],
    specialAbility: "Master of Islamic Biography",
    stats: {
      knowledge: 92,
      influence: 91,
      piety: 94,
      works: 93,
      leadership: 86
    },
    bio: "Al-Dhahabi was a Syrian Islamic scholar known for his historical and biographical works. His Siyar A'lam al-Nubala is the most comprehensive Islamic biography collection.",
    majorWorks: [
      "Siyar A'lam al-Nubala",
      "Tarikh al-Islam",
      "Mizan al-I'tidal"
    ],
    notableFor: [
      "Greatest Islamic biographical encyclopedia",
      "Critical hadith evaluator",
      "Student of Ibn Taymiyyah"
    ],
    colorTheme: {
      primary: "from-orange-500",
      secondary: "to-red-600"
    }
  },
  {
    id: 50,
    name: "Ibn Kathir",
    arabicName: "ابن كثير",
    title: "Tafsir Scholar",
    born: { hijri: 701, gregorian: 1301 },
    died: { hijri: 774, gregorian: 1373 },
    location: "Busra, Syria",
    rarity: "epic",
    level: 93,
    era: "Mamluk",
    madhab: "Shafi'i",
    expertise: ["Tafsir", "History", "Hadith"],
    specialAbility: "Master of Quranic Exegesis",
    stats: {
      knowledge: 93,
      influence: 92,
      piety: 90,
      works: 94,
      leadership: 85
    },
    bio: "Ibn Kathir was a Syrian Islamic scholar known for his Quran commentary and history. His Tafsir Ibn Kathir is one of the most widely used commentaries today.",
    majorWorks: [
      "Tafsir Ibn Kathir",
      "Al-Bidaya wa al-Nihaya",
      "Al-Sirah al-Nabawiyyah"
    ],
    notableFor: [
      "Most popular Tafsir worldwide",
      "Comprehensive Islamic history",
      "Student of Ibn Taymiyyah"
    ],
    colorTheme: {
      primary: "from-purple-500",
      secondary: "to-violet-600"
    }
  },
  {
    id: 51,
    name: "Al-Tabari",
    arabicName: "الطبري",
    title: "Historian & Exegete",
    born: { hijri: 224, gregorian: 838 },
    died: { hijri: 310, gregorian: 923 },
    location: "Amol, Iran",
    rarity: "legendary",
    level: 95,
    era: "Abbasid",
    madhab: "",
    expertise: ["Tafsir", "History", "Fiqh"],
    specialAbility: "Father of Islamic History",
    stats: {
      knowledge: 92,
      influence: 93,
      piety: 94,
      works: 96,
      leadership: 87
    },
    bio: "Al-Tabari was a Persian scholar who authored the monumental Tafsir al-Tabari and Tarikh al-Tabari. His works remain foundational in Islamic scholarship.",
    majorWorks: [
      "Tafsir al-Tabari",
      "Tarikh al-Tabari",
      "Ikhtilaf al-Fuqaha"
    ],
    notableFor: [
      "Greatest classical tafsir",
      "Most comprehensive early Islamic history",
      "Founded his own madhab briefly"
    ],
    colorTheme: {
      primary: "from-emerald-600",
      secondary: "to-green-700"
    }
  },
  {
    id: 52,
    name: "Rabia al-Adawiyya",
    arabicName: "رابعة العدوية",
    title: "Sufi Saint",
    born: { hijri: 95, gregorian: 716 },
    died: { hijri: 185, gregorian: 801 },
    location: "Basra, Iraq",
    rarity: "epic",
    level: 91,
    era: "Abbasid",
    madhab: "",
    expertise: ["Spirituality", "Devotion", "Piety"],
    specialAbility: "Pioneer of Divine Love",
    stats: {
      knowledge: 85,
      influence: 91,
      piety: 95,
      works: 82,
      leadership: 84
    },
    bio: "Rabia al-Adawiyya was one of the most famous Sufi saints, known for introducing the concept of selfless divine love into Sufism. Born into slavery, she became renowned for her piety.",
    majorWorks: [
      "Poetry of divine love",
      "Spiritual teachings",
      "Prayers and supplications"
    ],
    notableFor: [
      "Pioneer of love-centered Sufism",
      "Famous for her devotional prayers",
      "Rejected worldly attachments"
    ],
    colorTheme: {
      primary: "from-rose-500",
      secondary: "to-pink-600"
    }
  },
  {
    id: 53,
    name: "Junayd of Baghdad",
    arabicName: "الجنيد البغدادي",
    title: "Master of Sufis",
    born: { hijri: 215, gregorian: 830 },
    died: { hijri: 298, gregorian: 910 },
    location: "Baghdad, Iraq",
    rarity: "epic",
    level: 90,
    era: "Abbasid",
    madhab: "",
    expertise: ["Spirituality", "Wisdom", "Teaching"],
    specialAbility: "Chief of the Sufi Way",
    stats: {
      knowledge: 90,
      influence: 91,
      piety: 93,
      works: 86,
      leadership: 89
    },
    bio: "Junayd of Baghdad was a Persian mystic and one of the most famous Sufis. He is considered the chief of the 'sober' school of Sufism that remained within Islamic law.",
    majorWorks: [
      "Letters on Sufism",
      "Spiritual teachings",
      "Commentaries on mysticism"
    ],
    notableFor: [
      "Master of 'sober' Sufism",
      "Maintained balance with Sharia",
      "Teacher of many great Sufis"
    ],
    colorTheme: {
      primary: "from-indigo-500",
      secondary: "to-blue-600"
    }
  },
  {
    id: 54,
    name: "Al-Muhasibi",
    arabicName: "المحاسبي",
    title: "Self-Examination Scholar",
    born: { hijri: 165, gregorian: 781 },
    died: { hijri: 243, gregorian: 857 },
    location: "Basra, Iraq",
    rarity: "rare",
    level: 89,
    era: "Abbasid",
    madhab: "",
    expertise: ["Spirituality", "Psychology", "Piety"],
    specialAbility: "Pioneer of Self-Accounting",
    stats: {
      knowledge: 89,
      influence: 86,
      piety: 91,
      works: 88,
      leadership: 83
    },
    bio: "Al-Muhasibi was an early Muslim scholar who pioneered the psychology of the soul and self-examination (muhasaba). His works influenced Al-Ghazali greatly.",
    majorWorks: [
      "Al-Ri'aya li-Huquq Allah",
      "Al-Wasaya",
      "Al-Tawba"
    ],
    notableFor: [
      "Pioneer of Islamic psychology",
      "Developed self-examination methodology",
      "Major influence on Al-Ghazali"
    ],
    colorTheme: {
      primary: "from-slate-500",
      secondary: "to-gray-600"
    }
  },
  {
    id: 55,
    name: "Abdul Qadir Gilani",
    arabicName: "عبد القادر الجيلاني",
    title: "Qadiri Order Founder",
    born: { hijri: 470, gregorian: 1077 },
    died: { hijri: 561, gregorian: 1166 },
    location: "Gilan, Iran",
    rarity: "legendary",
    level: 93,
    era: "Seljuk",
    madhab: "Hanbali",
    expertise: ["Spirituality", "Preaching", "Influence"],
    specialAbility: "Sultan of the Saints",
    stats: {
      knowledge: 91,
      influence: 95,
      piety: 94,
      works: 89,
      leadership: 93
    },
    bio: "Abdul Qadir Gilani was a Hanbali scholar and Sufi saint. He founded the Qadiriyya tariqa, one of the oldest and most widespread Sufi orders.",
    majorWorks: [
      "Futuh al-Ghayb",
      "Al-Ghunya li-Talibi",
      "Al-Fath al-Rabbani"
    ],
    notableFor: [
      "Founder of Qadiriyya order",
      "Known as Sultan of Saints",
      "Millions of followers worldwide"
    ],
    colorTheme: {
      primary: "from-green-600",
      secondary: "to-emerald-700"
    }
  },
  {
    id: 56,
    name: "Farid al-Din Attar",
    arabicName: "فريد الدين عطار",
    title: "Sufi Poet",
    born: { hijri: 540, gregorian: 1145 },
    died: { hijri: 618, gregorian: 1221 },
    location: "Nishapur, Iran",
    rarity: "epic",
    level: 90,
    era: "Ghurid",
    madhab: "",
    expertise: ["Poetry", "Spirituality", "Wisdom"],
    specialAbility: "Master of Spiritual Poetry",
    stats: {
      knowledge: 88,
      influence: 90,
      piety: 91,
      works: 92,
      leadership: 82
    },
    bio: "Farid al-Din Attar was a Persian poet and Sufi. His Conference of the Birds is one of the masterpieces of Persian literature and Sufi thought.",
    majorWorks: [
      "The Conference of the Birds",
      "Tadhkirat al-Awliya",
      "Ilahi-nama"
    ],
    notableFor: [
      "Conference of the Birds allegory",
      "Influenced Rumi greatly",
      "Master of spiritual allegory"
    ],
    colorTheme: {
      primary: "from-purple-500",
      secondary: "to-violet-600"
    }
  },
  {
    id: 57,
    name: "Al-Ash'ari",
    arabicName: "الأشعري",
    title: "Ash'ari School Founder",
    born: { hijri: 260, gregorian: 874 },
    died: { hijri: 324, gregorian: 936 },
    location: "Basra, Iraq",
    rarity: "legendary",
    level: 94,
    era: "Abbasid",
    madhab: "Shafi'i",
    expertise: ["Theology", "Debate", "Logic"],
    specialAbility: "Defender of Sunni Theology",
    stats: {
      knowledge: 93,
      influence: 95,
      piety: 92,
      works: 90,
      leadership: 90
    },
    bio: "Al-Ash'ari was an Arab theologian and founder of the Ash'ari school of theology. Originally a Mu'tazilite, he became the main defender of Sunni orthodoxy.",
    majorWorks: [
      "Al-Ibanah",
      "Maqalat al-Islamiyyin",
      "Al-Luma'"
    ],
    notableFor: [
      "Founded Ash'ari theology",
      "Defended Sunni beliefs",
      "Majority of Sunnis follow his school"
    ],
    colorTheme: {
      primary: "from-blue-600",
      secondary: "to-indigo-700"
    }
  },
  {
    id: 58,
    name: "Al-Maturidi",
    arabicName: "الماتريدي",
    title: "Maturidi School Founder",
    born: { hijri: 238, gregorian: 853 },
    died: { hijri: 333, gregorian: 944 },
    location: "Samarkand, Uzbekistan",
    rarity: "legendary",
    level: 93,
    era: "Samanid",
    madhab: "Hanafi",
    expertise: ["Theology", "Logic", "Balance"],
    specialAbility: "Harmonizer of Reason and Revelation",
    stats: {
      knowledge: 92,
      influence: 93,
      piety: 91,
      works: 89,
      leadership: 89
    },
    bio: "Al-Maturidi was a Persian Sunni theologian who founded the Maturidi school of theology. His school is followed by the majority of Hanafis worldwide.",
    majorWorks: [
      "Kitab al-Tawhid",
      "Ta'wilat Ahl al-Sunnah",
      "Sharh al-Fiqh al-Akbar"
    ],
    notableFor: [
      "Founded Maturidi theology",
      "Balanced reason and revelation",
      "Second major Sunni theology school"
    ],
    colorTheme: {
      primary: "from-teal-600",
      secondary: "to-cyan-700"
    }
  },
  {
    id: 59,
    name: "Al-Juwayni",
    arabicName: "الجويني",
    title: "Imam of the Two Harams",
    born: { hijri: 419, gregorian: 1028 },
    died: { hijri: 478, gregorian: 1085 },
    location: "Nishapur, Iran",
    rarity: "epic",
    level: 91,
    era: "Seljuk",
    madhab: "Shafi'i",
    expertise: ["Theology", "Fiqh", "Teaching"],
    specialAbility: "Master of Usul",
    stats: {
      knowledge: 90,
      influence: 90,
      piety: 91,
      works: 89,
      leadership: 88
    },
    bio: "Al-Juwayni was a Persian Sunni scholar and the teacher of Al-Ghazali. He taught in Mecca and Medina, earning the title 'Imam of the Two Harams.'",
    majorWorks: [
      "Al-Irshad",
      "Al-Burhan",
      "Nihayat al-Matlab"
    ],
    notableFor: [
      "Teacher of Al-Ghazali",
      "Major Ash'ari theologian",
      "Taught in both holy cities"
    ],
    colorTheme: {
      primary: "from-amber-500",
      secondary: "to-orange-600"
    }
  },
  {
    id: 60,
    name: "Fakhr al-Din al-Razi",
    arabicName: "فخر الدين الرازي",
    title: "Polymath Theologian",
    born: { hijri: 544, gregorian: 1150 },
    died: { hijri: 606, gregorian: 1210 },
    location: "Ray, Iran",
    rarity: "epic",
    level: 93,
    era: "Khwarazmian",
    madhab: "Shafi'i",
    expertise: ["Theology", "Tafsir", "Debate"],
    specialAbility: "Master of Rational Theology",
    stats: {
      knowledge: 92,
      influence: 91,
      piety: 93,
      works: 94,
      leadership: 87
    },
    bio: "Fakhr al-Din al-Razi was a Persian polymath who authored major works in tafsir and theology. His Tafsir al-Kabir is one of the largest Quranic commentaries.",
    majorWorks: [
      "Tafsir al-Kabir (Mafatih al-Ghayb)",
      "Al-Arba'in fi Usul al-Din",
      "Al-Matalib al-'Aliya"
    ],
    notableFor: [
      "Massive tafsir covering rational theology",
      "Debated philosophers and mutakallimun",
      "Encyclopedic knowledge"
    ],
    colorTheme: {
      primary: "from-violet-500",
      secondary: "to-purple-600"
    }
  },
  {
    id: 61,
    name: "Ibn Abi Zayd al-Qayrawani",
    arabicName: "ابن أبي زيد القيرواني",
    title: "Maliki Jurist",
    born: { hijri: 310, gregorian: 922 },
    died: { hijri: 386, gregorian: 996 },
    location: "Qayrawan, Tunisia",
    rarity: "epic",
    level: 90,
    era: "Fatimid",
    madhab: "Maliki",
    expertise: ["Fiqh", "Teaching", "Precision"],
    specialAbility: "Little Malik",
    stats: {
      knowledge: 90,
      influence: 89,
      piety: 88,
      works: 90,
      leadership: 86
    },
    bio: "Ibn Abi Zayd al-Qayrawani was a Maliki scholar known for his Risala, a primer on Maliki fiqh that is still used as a basic text today.",
    majorWorks: [
      "Al-Risala",
      "Al-Nawadir wal-Ziyadat",
      "Mukhtasar al-Mudawwana"
    ],
    notableFor: [
      "Called 'Little Malik'",
      "His Risala taught worldwide",
      "Preserved Maliki fiqh in North Africa"
    ],
    colorTheme: {
      primary: "from-orange-500",
      secondary: "to-amber-600"
    }
  },
  {
    id: 62,
    name: "Al-Qadi Iyad",
    arabicName: "القاضي عياض",
    title: "Al-Shifa Author",
    born: { hijri: 476, gregorian: 1083 },
    died: { hijri: 544, gregorian: 1149 },
    location: "Ceuta, Morocco",
    rarity: "epic",
    level: 91,
    era: "Almoravid",
    madhab: "Maliki",
    expertise: ["Hadith", "Seerah", "Writing"],
    specialAbility: "Defender of Prophetic Honor",
    stats: {
      knowledge: 90,
      influence: 91,
      piety: 93,
      works: 92,
      leadership: 87
    },
    bio: "Al-Qadi Iyad was an Andalusian judge and scholar best known for Al-Shifa, a comprehensive work on the Prophet Muhammad's rights and characteristics.",
    majorWorks: [
      "Al-Shifa bi Ta'rif Huquq al-Mustafa",
      "Tartib al-Madarik",
      "Mashaariq al-Anwaar"
    ],
    notableFor: [
      "Al-Shifa most beloved Seerah work",
      "Chief Judge of Ceuta and Granada",
      "Master of Maliki biographical tradition"
    ],
    colorTheme: {
      primary: "from-rose-500",
      secondary: "to-red-600"
    }
  },
  {
    id: 63,
    name: "Al-Qarafi",
    arabicName: "القرافي",
    title: "Maliki Scholar",
    born: { hijri: 626, gregorian: 1228 },
    died: { hijri: 684, gregorian: 1285 },
    location: "Cairo, Egypt",
    rarity: "rare",
    level: 89,
    era: "Mamluk",
    madhab: "Maliki",
    expertise: ["Fiqh", "Legal Theory", "Innovation"],
    specialAbility: "Master of Legal Maxims",
    stats: {
      knowledge: 89,
      influence: 87,
      piety: 90,
      works: 91,
      leadership: 84
    },
    bio: "Al-Qarafi was an Egyptian Maliki jurist known for his work on legal theory and distinguishing between different types of prophetic actions.",
    majorWorks: [
      "Al-Furuq",
      "Al-Dhakhira",
      "Anwar al-Buruq"
    ],
    notableFor: [
      "Distinguishing legal categories",
      "Work on usul al-fiqh",
      "Clarified Maliki legal theory"
    ],
    colorTheme: {
      primary: "from-cyan-500",
      secondary: "to-teal-600"
    }
  },
  {
    id: 64,
    name: "Ibn Qudamah",
    arabicName: "ابن قدامة",
    title: "Al-Mughni Author",
    born: { hijri: 541, gregorian: 1147 },
    died: { hijri: 620, gregorian: 1223 },
    location: "Jerusalem",
    rarity: "epic",
    level: 92,
    era: "Ayyubid",
    madhab: "Hanbali",
    expertise: ["Fiqh", "Scholarship", "Precision"],
    specialAbility: "Encyclopedia of Hanbali Law",
    stats: {
      knowledge: 92,
      influence: 91,
      piety: 93,
      works: 94,
      leadership: 86
    },
    bio: "Ibn Qudamah was a Palestinian Hanbali scholar and author of Al-Mughni, a comprehensive encyclopedia of Islamic jurisprudence comparing all four madhabs.",
    majorWorks: [
      "Al-Mughni",
      "Al-Umdah",
      "Rawdat al-Nazir"
    ],
    notableFor: [
      "Al-Mughni: encyclopedia of comparative fiqh",
      "Participated in fighting Crusaders",
      "Systematized Hanbali fiqh"
    ],
    colorTheme: {
      primary: "from-blue-500",
      secondary: "to-indigo-600"
    }
  },
  {
    id: 65,
    name: "Ibn Rajab",
    arabicName: "ابن رجب",
    title: "Hanbali Scholar",
    born: { hijri: 736, gregorian: 1335 },
    died: { hijri: 795, gregorian: 1393 },
    location: "Baghdad, Iraq",
    rarity: "epic",
    level: 91,
    era: "Mamluk",
    madhab: "Hanbali",
    expertise: ["Hadith Commentary", "Spirituality", "Writing"],
    specialAbility: "Heart-Focused Scholar",
    stats: {
      knowledge: 90,
      influence: 89,
      piety: 93,
      works: 92,
      leadership: 85
    },
    bio: "Ibn Rajab was a Hanbali scholar known for his commentary on Nawawi's 40 Hadith and works combining hadith science with spirituality.",
    majorWorks: [
      "Jami' al-'Ulum wal-Hikam",
      "Fath al-Bari (Ibn Rajab)",
      "Lata'if al-Ma'arif"
    ],
    notableFor: [
      "Best commentary on Nawawi's 40",
      "Combined scholarship with spirituality",
      "Wrote on seasons of worship"
    ],
    colorTheme: {
      primary: "from-emerald-500",
      secondary: "to-green-600"
    }
  },
  {
    id: 66,
    name: "Al-Muzani",
    arabicName: "المزني",
    title: "Al-Shafi'i's Student",
    born: { hijri: 175, gregorian: 791 },
    died: { hijri: 264, gregorian: 878 },
    location: "Egypt",
    rarity: "rare",
    level: 88,
    era: "Abbasid",
    madhab: "Shafi'i",
    expertise: ["Fiqh", "Logic", "Devotion"],
    specialAbility: "Transmitter of Shafi'i Fiqh",
    stats: {
      knowledge: 88,
      influence: 86,
      piety: 90,
      works: 87,
      leadership: 83
    },
    bio: "Al-Muzani was the most prominent student of Imam al-Shafi'i and the primary transmitter of his new (Egyptian) legal opinions.",
    majorWorks: [
      "Mukhtasar al-Muzani",
      "Al-Jami' al-Kabir",
      "Al-Mabsut"
    ],
    notableFor: [
      "Main transmitter of Shafi'i's later views",
      "His Mukhtasar widely commented upon",
      "Shafi'i praised his debating skills"
    ],
    colorTheme: {
      primary: "from-lime-500",
      secondary: "to-green-600"
    }
  },
  {
    id: 67,
    name: "Ibn al-Salah",
    arabicName: "ابن الصلاح",
    title: "Hadith Methodology Scholar",
    born: { hijri: 577, gregorian: 1181 },
    died: { hijri: 643, gregorian: 1245 },
    location: "Shahrazur, Iraq",
    rarity: "epic",
    level: 92,
    era: "Ayyubid",
    madhab: "Shafi'i",
    expertise: ["Hadith Science", "Teaching", "Precision"],
    specialAbility: "Systematizer of Hadith Sciences",
    stats: {
      knowledge: 93,
      influence: 91,
      piety: 90,
      works: 92,
      leadership: 86
    },
    bio: "Ibn al-Salah was a Kurdish scholar whose Muqaddimah became the foundational text for hadith sciences methodology.",
    majorWorks: [
      "Muqaddimat Ibn al-Salah",
      "Fatawa Ibn al-Salah",
      "Tabaqat al-Fuqaha"
    ],
    notableFor: [
      "Defined hadith sciences terminology",
      "His methodology still used today",
      "Head of Dar al-Hadith in Damascus"
    ],
    colorTheme: {
      primary: "from-purple-500",
      secondary: "to-fuchsia-600"
    }
  },
  {
    id: 68,
    name: "Al-Sarakhsi",
    arabicName: "السرخسي",
    title: "Al-Mabsut Author",
    born: { hijri: 400, gregorian: 1009 },
    died: { hijri: 483, gregorian: 1090 },
    location: "Sarakhsi, Iran",
    rarity: "epic",
    level: 91,
    era: "Seljuk",
    madhab: "Hanafi",
    expertise: ["Fiqh", "Writing", "Memory"],
    specialAbility: "Dictator of Legal Masterpiece",
    stats: {
      knowledge: 91,
      influence: 89,
      piety: 93,
      works: 94,
      leadership: 84
    },
    bio: "Al-Sarakhsi was a Hanafi jurist who dictated his 30-volume Al-Mabsut while imprisoned in a well. It remains a cornerstone of Hanafi jurisprudence.",
    majorWorks: [
      "Al-Mabsut",
      "Usul al-Sarakhsi",
      "Sharh al-Siyar al-Kabir"
    ],
    notableFor: [
      "Dictated masterwork from prison",
      "30 volumes from memory",
      "Foundational Hanafi text"
    ],
    colorTheme: {
      primary: "from-amber-600",
      secondary: "to-yellow-700"
    }
  },
  {
    id: 69,
    name: "Al-Kasani",
    arabicName: "الكاساني",
    title: "Bada'i Author",
    born: { hijri: 500, gregorian: 1106 },
    died: { hijri: 587, gregorian: 1191 },
    location: "Kasan, Uzbekistan",
    rarity: "epic",
    level: 90,
    era: "Seljuk",
    madhab: "Hanafi",
    expertise: ["Fiqh", "Organization", "Detail"],
    specialAbility: "Organizer of Hanafi Law",
    stats: {
      knowledge: 90,
      influence: 88,
      piety: 91,
      works: 92,
      leadership: 85
    },
    bio: "Al-Kasani was a Central Asian Hanafi jurist whose Bada'i al-Sana'i reorganized Hanafi fiqh in a more systematic format.",
    majorWorks: [
      "Bada'i al-Sana'i",
      "Commentary on al-Tuhfah"
    ],
    notableFor: [
      "Reorganized Hanafi fiqh systematically",
      "Married his teacher's daughter for his book",
      "Made Hanafi fiqh accessible"
    ],
    colorTheme: {
      primary: "from-teal-500",
      secondary: "to-emerald-600"
    }
  },
  {
    id: 70,
    name: "Ibn Hajar al-Haytami",
    arabicName: "ابن حجر الهيتمي",
    title: "Shafi'i Mufti",
    born: { hijri: 909, gregorian: 1503 },
    died: { hijri: 974, gregorian: 1567 },
    location: "Egypt",
    rarity: "epic",
    level: 90,
    era: "Ottoman",
    madhab: "Shafi'i",
    expertise: ["Fiqh", "Fatwas", "Teaching"],
    specialAbility: "Mufti of Mecca",
    stats: {
      knowledge: 90,
      influence: 89,
      piety: 92,
      works: 91,
      leadership: 87
    },
    bio: "Ibn Hajar al-Haytami was an Egyptian Shafi'i scholar who became the leading authority in Mecca. His fatwas are still referenced today.",
    majorWorks: [
      "Tuhfat al-Muhtaj",
      "Al-Zawajir",
      "Al-Sawa'iq al-Muhriqa"
    ],
    notableFor: [
      "Reference for Shafi'i fatwas",
      "Wrote on major sins",
      "Settled in Mecca"
    ],
    colorTheme: {
      primary: "from-rose-500",
      secondary: "to-pink-600"
    }
  },
  {
    id: 71,
    name: "Muhammad ibn Abd al-Wahhab",
    arabicName: "محمد بن عبد الوهاب",
    title: "Arabian Reformer",
    born: { hijri: 1115, gregorian: 1703 },
    died: { hijri: 1206, gregorian: 1792 },
    location: "Uyaynah, Arabia",
    rarity: "epic",
    level: 90,
    era: "Ottoman",
    madhab: "Hanbali",
    expertise: ["Creed", "Reform", "Courage"],
    specialAbility: "Reviver of Tawhid",
    stats: {
      knowledge: 90,
      influence: 93,
      piety: 91,
      works: 88,
      leadership: 91
    },
    bio: "Muhammad ibn Abd al-Wahhab was an Arabian Islamic scholar who called for a return to pure monotheism and strict adherence to Quran and Sunnah.",
    majorWorks: [
      "Kitab al-Tawhid",
      "Kashf al-Shubuhat",
      "Thalatha al-Usul"
    ],
    notableFor: [
      "Called for pure monotheism",
      "Alliance with Saudi family",
      "Major influence in modern Islam"
    ],
    colorTheme: {
      primary: "from-green-600",
      secondary: "to-emerald-700"
    }
  },
  {
    id: 72,
    name: "Al-Shawkani",
    arabicName: "الشوكاني",
    title: "Yemeni Scholar",
    born: { hijri: 1173, gregorian: 1759 },
    died: { hijri: 1255, gregorian: 1839 },
    location: "Shawkan, Yemen",
    rarity: "epic",
    level: 92,
    era: "Ottoman",
    madhab: "",
    expertise: ["Hadith", "Independence", "Tafsir"],
    specialAbility: "Independent Mujtahid",
    stats: {
      knowledge: 92,
      influence: 90,
      piety: 91,
      works: 93,
      leadership: 88
    },
    bio: "Al-Shawkani was a Yemeni Islamic scholar who advocated for independent reasoning (ijtihad) rather than strict adherence to any one school.",
    majorWorks: [
      "Nayl al-Awtar",
      "Fath al-Qadir",
      "Irshad al-Fuhul"
    ],
    notableFor: [
      "Called for fresh ijtihad",
      "Major hadith commentary",
      "Chief Judge of Yemen"
    ],
    colorTheme: {
      primary: "from-yellow-500",
      secondary: "to-amber-600"
    }
  },
  {
    id: 73,
    name: "Al-Qurtubi",
    arabicName: "القرطبي",
    title: "Tafsir Scholar",
    born: { hijri: 611, gregorian: 1214 },
    died: { hijri: 671, gregorian: 1273 },
    location: "Cordoba, Spain",
    rarity: "epic",
    level: 92,
    era: "Almohad",
    madhab: "Maliki",
    expertise: ["Tafsir", "Fiqh", "Compilation"],
    specialAbility: "Master of Legal Tafsir",
    stats: {
      knowledge: 92,
      influence: 90,
      piety: 91,
      works: 93,
      leadership: 85
    },
    bio: "Al-Qurtubi was an Andalusian Maliki scholar known for his comprehensive tafsir that focuses on legal rulings derived from the Quran.",
    majorWorks: [
      "Al-Jami' li-Ahkam al-Quran",
      "Al-Tadhkira",
      "Al-Tidhkar"
    ],
    notableFor: [
      "Focus on fiqh in tafsir",
      "Left Spain after Reconquista",
      "Settled and died in Egypt"
    ],
    colorTheme: {
      primary: "from-orange-500",
      secondary: "to-red-600"
    }
  },
  {
    id: 74,
    name: "Ahmad Sirhindi",
    arabicName: "أحمد السرهندي",
    title: "Mujaddid Alf Thani",
    born: { hijri: 971, gregorian: 1564 },
    died: { hijri: 1034, gregorian: 1624 },
    location: "Sirhind, India",
    rarity: "epic",
    level: 91,
    era: "Mughal",
    madhab: "Hanafi",
    expertise: ["Spirituality", "Reform", "Influence"],
    specialAbility: "Reviver of Second Millennium",
    stats: {
      knowledge: 90,
      influence: 92,
      piety: 93,
      works: 89,
      leadership: 91
    },
    bio: "Ahmad Sirhindi was a Naqshbandi Sufi saint who opposed Emperor Akbar's religious syncretism and is credited with preserving Islamic orthodoxy in India.",
    majorWorks: [
      "Maktubat",
      "Ithbat al-Nubuwwah",
      "Radd-i Rawafid"
    ],
    notableFor: [
      "Called Mujaddid of Second Millennium",
      "Opposed religious syncretism",
      "Revived Islamic practice in Mughal India"
    ],
    colorTheme: {
      primary: "from-indigo-500",
      secondary: "to-blue-600"
    }
  },
  {
    id: 75,
    name: "Ashraf Ali Thanwi",
    arabicName: "أشرف علي التهانوي",
    title: "Hakim al-Ummah",
    born: { hijri: 1280, gregorian: 1863 },
    died: { hijri: 1362, gregorian: 1943 },
    location: "Thana Bhawan, India",
    rarity: "epic",
    level: 92,
    era: "British India",
    madhab: "Hanafi",
    expertise: ["Spirituality", "Writing", "Teaching"],
    specialAbility: "Sage of the Ummah",
    stats: {
      knowledge: 91,
      influence: 92,
      piety: 94,
      works: 95,
      leadership: 90
    },
    bio: "Ashraf Ali Thanwi was one of the leading Islamic scholars of South Asia, known for his spiritual guidance and extensive writings on practical Islam.",
    majorWorks: [
      "Bahishti Zewar",
      "Bayan al-Quran",
      "Al-Tashil"
    ],
    notableFor: [
      "Called Hakim al-Ummah (Sage)",
      "Bahishti Zewar in millions of homes",
      "Made Islam accessible to common people"
    ],
    colorTheme: {
      primary: "from-green-500",
      secondary: "to-teal-600"
    }
  },
  {
    id: 76,
    name: "Ebussuud Efendi",
    arabicName: "أبو السعود أفندي",
    title: "Shaykh al-Islam",
    born: { hijri: 896, gregorian: 1490 },
    died: { hijri: 982, gregorian: 1574 },
    location: "Iskilip, Turkey",
    rarity: "epic",
    level: 92,
    era: "Ottoman",
    madhab: "Hanafi",
    expertise: ["Fiqh", "Legal Opinion", "Administration"],
    specialAbility: "Grand Mufti of the Ottomans",
    stats: {
      knowledge: 91,
      influence: 93,
      piety: 90,
      works: 92,
      leadership: 93
    },
    bio: "Ebussuud Efendi was the longest-serving Shaykh al-Islam of the Ottoman Empire, serving under Suleiman the Magnificent. He reformed Ottoman law.",
    majorWorks: [
      "Irshad al-Aql al-Salim",
      "Fatawa",
      "Legal codifications"
    ],
    notableFor: [
      "Shaykh al-Islam for 30 years",
      "Harmonized Ottoman and Islamic law",
      "Served under Suleiman"
    ],
    colorTheme: {
      primary: "from-red-600",
      secondary: "to-rose-700"
    }
  },
  {
    id: 77,
    name: "Bediuzzaman Said Nursi",
    arabicName: "بديع الزمان سعيد النورسي",
    title: "Risale-i Nur Author",
    born: { hijri: 1294, gregorian: 1877 },
    died: { hijri: 1379, gregorian: 1960 },
    location: "Nurs, Turkey",
    rarity: "epic",
    level: 91,
    era: "Modern",
    madhab: "Shafi'i",
    expertise: ["Tafsir", "Apologetics", "Writing"],
    specialAbility: "Defender of Faith in Modern Age",
    stats: {
      knowledge: 90,
      influence: 92,
      piety: 91,
      works: 93,
      leadership: 89
    },
    bio: "Bediuzzaman Said Nursi was a Kurdish Islamic scholar who wrote the Risale-i Nur collection to strengthen faith in the face of atheism and materialism.",
    majorWorks: [
      "Risale-i Nur Collection",
      "Sozler (The Words)",
      "Mektubat (Letters)"
    ],
    notableFor: [
      "Defended Islam against atheism",
      "Wrote from prison and exile",
      "Millions of followers worldwide"
    ],
    colorTheme: {
      primary: "from-sky-500",
      secondary: "to-blue-600"
    }
  },
  {
    id: 78,
    name: "Usman dan Fodio",
    arabicName: "عثمان دان فوديو",
    title: "Sokoto Caliphate Founder",
    born: { hijri: 1167, gregorian: 1754 },
    died: { hijri: 1232, gregorian: 1817 },
    location: "Gobir, Nigeria",
    rarity: "epic",
    level: 91,
    era: "Colonial",
    madhab: "Maliki",
    expertise: ["Reform", "Leadership", "Scholarship"],
    specialAbility: "Reviver of West Africa",
    stats: {
      knowledge: 88,
      influence: 93,
      piety: 91,
      works: 90,
      leadership: 94
    },
    bio: "Usman dan Fodio was a Fulani scholar and Islamic reformer who founded the Sokoto Caliphate, one of the largest states in 19th century Africa.",
    majorWorks: [
      "Ihya al-Sunnah",
      "Nur al-Albab",
      "Bayan Wujub al-Hijra"
    ],
    notableFor: [
      "Founded Sokoto Caliphate",
      "Major Islamic revival in West Africa",
      "Established Islamic scholarship centers"
    ],
    colorTheme: {
      primary: "from-yellow-600",
      secondary: "to-amber-700"
    }
  },
  {
    id: 79,
    name: "Ahmad Baba al-Timbukti",
    arabicName: "أحمد بابا التمبكتي",
    title: "Timbuktu Scholar",
    born: { hijri: 963, gregorian: 1556 },
    died: { hijri: 1036, gregorian: 1627 },
    location: "Timbuktu, Mali",
    rarity: "epic",
    level: 90,
    era: "Songhai",
    madhab: "Maliki",
    expertise: ["Writing", "Fiqh", "Biography"],
    specialAbility: "Jewel of Timbuktu",
    stats: {
      knowledge: 91,
      influence: 89,
      piety: 90,
      works: 92,
      leadership: 86
    },
    bio: "Ahmad Baba was the most prominent scholar of medieval Timbuktu. He wrote over 40 books and had a library of 1,600 volumes.",
    majorWorks: [
      "Nayl al-Ibtihaj",
      "Mi'raj al-Su'ud",
      "Kifayat al-Muhtaj"
    ],
    notableFor: [
      "Greatest scholar of Timbuktu",
      "Biographical dictionary of Maliki scholars",
      "Spoke against slavery of Muslims"
    ],
    colorTheme: {
      primary: "from-amber-500",
      secondary: "to-orange-600"
    }
  },
  {
    id: 80,
    name: "Muhammad Rashid Rida",
    arabicName: "محمد رشيد رضا",
    title: "Al-Manar Journal Founder",
    born: { hijri: 1282, gregorian: 1865 },
    died: { hijri: 1354, gregorian: 1935 },
    location: "Tripoli, Lebanon",
    rarity: "rare",
    level: 89,
    era: "Modern",
    madhab: "",
    expertise: ["Reform", "Writing", "Influence"],
    specialAbility: "Voice of Islamic Reform",
    stats: {
      knowledge: 90,
      influence: 91,
      piety: 88,
      works: 89,
      leadership: 87
    },
    bio: "Muhammad Rashid Rida was a Syrian Islamic scholar and reformer who continued Muhammad Abduh's reform movement through his influential Al-Manar journal.",
    majorWorks: [
      "Tafsir al-Manar",
      "Al-Khilafa",
      "Al-Wahhabiyun wal-Hijaz"
    ],
    notableFor: [
      "Al-Manar journal for 37 years",
      "Continued Abduh's reform",
      "Bridge between traditionalism and reform"
    ],
    colorTheme: {
      primary: "from-cyan-500",
      secondary: "to-teal-600"
    }
  },
  {
    id: 81,
    name: "Ahmad Musa Jibril",
    arabicName: "أحمد موسى جبريل",
    title: "Palestinian-American Scholar",
    born: { hijri: 1391, gregorian: 1971 },
    died: null,
    location: "Michigan, USA",
    rarity: "rare",
    level: 85,
    era: "Modern",
    madhab: "Salafi",
    expertise: ["Quran", "Hadith", "Fiqh"],
    specialAbility: "Voice of the Youth",
    stats: {
      knowledge: 92,
      influence: 88,
      piety: 85,
      works: 80,
      leadership: 82
    },
    bio: "Ahmad Musa Jibril is a Palestinian-American Islamic scholar who memorized the Quran at age 11 in Madinah. He studied under renowned scholars including Ibn Baz, Ibn Uthaymeen, and Shaykh Safi ur-Rahman Mubarakpuri. He holds degrees from the Islamic University of Madinah and a JD/LLM from Michigan.",
    majorWorks: [
      "Tafsir lectures",
      "Stories of the Prophets series",
      "Islamic awakening lectures"
    ],
    notableFor: [
      "Memorized Sahih Bukhari and Muslim before high school",
      "Studied under major Saudi scholars",
      "Influential online dawah presence"
    ],
    colorTheme: {
      primary: "from-emerald-500",
      secondary: "to-green-600"
    }
  },
  {
    id: 82,
    name: "Ibn al-Khattab",
    arabicName: "ابن الخطاب",
    title: "Emir of the Mujahideen",
    born: { hijri: 1389, gregorian: 1969 },
    died: { hijri: 1423, gregorian: 2002 },
    location: "Arar, Saudi Arabia",
    rarity: "legendary",
    level: 92,
    era: "Modern",
    madhab: "",
    expertise: ["Military Strategy", "Leadership", "Guerrilla Warfare"],
    specialAbility: "Lion of Chechnya",
    stats: {
      knowledge: 75,
      influence: 95,
      piety: 88,
      works: 70,
      leadership: 98
    },
    bio: "Samir Salih Abdullah al-Suwaylim, known as Ibn al-Khattab or Emir Khattab, was a Saudi-born commander who fought in Afghanistan, Tajikistan, and Chechnya. He became a legendary figure in the Chechen resistance, establishing training camps and leading devastating ambushes against Russian forces alongside Shamil Basayev.",
    majorWorks: [
      "Established Mujahideen training camps",
      "Mountain Battle victory",
      "Zhani-Vedeno ambush"
    ],
    notableFor: [
      "Commander of Chechen Mujahideen",
      "Pioneer of combat videography for dawah",
      "Martyred by FSB poisoning in 2002"
    ],
    colorTheme: {
      primary: "from-red-600",
      secondary: "to-orange-700"
    }
  },

  // ==========================================
  // HANBALI SCHOLARS (New Additions)
  // ==========================================
  {
    id: 83,
    name: "Abu Ya'la al-Farra",
    arabicName: "أبو يعلى الفراء",
    title: "Qadi of the Hanbalis",
    born: { hijri: 380, gregorian: 990 },
    died: { hijri: 458, gregorian: 1066 },
    location: "Baghdad, Iraq",
    rarity: "epic",
    level: 88,
    era: "Medieval",
    madhab: "Hanbali",
    expertise: ["Fiqh", "Usul al-Fiqh", "Political Jurisprudence"],
    specialAbility: "Systematizer of Hanbali Political Fiqh",
    stats: {
      knowledge: 92,
      influence: 85,
      piety: 88,
      works: 90,
      leadership: 82
    },
    bio: "Abu Ya'la Muhammad ibn al-Husayn al-Farra was a leading Hanbali jurist who systematized Hanbali political fiqh. His work 'Al-Ahkam al-Sultaniyyah' parallels al-Mawardi's Shafi'i work and established principles of Islamic governance from a Hanbali perspective.",
    majorWorks: [
      "Al-Ahkam al-Sultaniyyah (The Ordinances of Government)",
      "Al-Uddah fi Usul al-Fiqh",
      "Al-Mu'tamad fi Usul al-Din"
    ],
    notableFor: [
      "Chief Hanbali judge of Baghdad",
      "Systematized Hanbali political theory",
      "Teacher of Ibn Aqil"
    ],
    colorTheme: {
      primary: "from-red-500",
      secondary: "to-rose-600"
    }
  },
  {
    id: 84,
    name: "Ibn Aqil",
    arabicName: "ابن عقيل",
    title: "Author of Al-Funun",
    born: { hijri: 431, gregorian: 1040 },
    died: { hijri: 513, gregorian: 1119 },
    location: "Baghdad, Iraq",
    rarity: "epic",
    level: 90,
    era: "Medieval",
    madhab: "Hanbali",
    expertise: ["Fiqh", "Theology", "Philosophy", "Literature"],
    specialAbility: "Master of All Arts",
    stats: {
      knowledge: 96,
      influence: 88,
      piety: 85,
      works: 99,
      leadership: 78
    },
    bio: "Abu al-Wafa Ali ibn Aqil was one of the most brilliant Hanbali scholars. His magnum opus 'Al-Funun' was reportedly 800 volumes, making it the largest Arabic book ever written. Though most is lost, fragments show his mastery across all Islamic sciences.",
    majorWorks: [
      "Al-Funun (The Arts) - 800 volumes",
      "Al-Wadih fi Usul al-Fiqh",
      "Kitab al-Jadal"
    ],
    notableFor: [
      "Author of largest Arabic book ever written",
      "Bridge between Hanbalism and rationalism",
      "Defended use of reason in jurisprudence"
    ],
    colorTheme: {
      primary: "from-red-500",
      secondary: "to-amber-600"
    }
  },
  {
    id: 85,
    name: "Ibn al-Jawzi",
    arabicName: "ابن الجوزي",
    title: "Prolific Hanbali Author",
    born: { hijri: 510, gregorian: 1116 },
    died: { hijri: 597, gregorian: 1201 },
    location: "Baghdad, Iraq",
    rarity: "legendary",
    level: 94,
    era: "Medieval",
    madhab: "Hanbali",
    expertise: ["Hadith", "Tafsir", "History", "Preaching"],
    specialAbility: "Scribe of 700 Works",
    stats: {
      knowledge: 95,
      influence: 93,
      piety: 90,
      works: 99,
      leadership: 85
    },
    bio: "Abu al-Faraj ibn al-Jawzi was one of the most prolific Muslim scholars in history, authoring over 700 works. A Hanbali polymath, he excelled in hadith, tafsir, history, and was famous for his powerful sermons that drew thousands.",
    majorWorks: [
      "Zad al-Masir (Provisions for the Journey) - Tafsir",
      "Al-Muntazam (The Systematic History)",
      "Talbis Iblis (The Devil's Deception)",
      "Sifat al-Safwa"
    ],
    notableFor: [
      "Over 700 authored works",
      "Famous preacher drawing 100,000 attendees",
      "Grandfather of historian Sibt ibn al-Jawzi"
    ],
    colorTheme: {
      primary: "from-red-600",
      secondary: "to-rose-700"
    }
  },
  {
    id: 86,
    name: "Ibn Muflih",
    arabicName: "ابن مفلح",
    title: "Master of Al-Furu'",
    born: { hijri: 710, gregorian: 1310 },
    died: { hijri: 763, gregorian: 1362 },
    location: "Damascus, Syria",
    rarity: "epic",
    level: 89,
    era: "Late Medieval",
    madhab: "Hanbali",
    expertise: ["Fiqh", "Legal Methodology", "Ethics"],
    specialAbility: "Hanbali Juristic Detail",
    stats: {
      knowledge: 94,
      influence: 86,
      piety: 90,
      works: 92,
      leadership: 75
    },
    bio: "Shams al-Din Ibn Muflih was a prominent student of Ibn Taymiyyah and author of 'Al-Furu', one of the most detailed Hanbali fiqh manuals. His work systematically presents Hanbali opinions on practical jurisprudence.",
    majorWorks: [
      "Al-Furu' (The Branches) - Detailed Fiqh Manual",
      "Al-Adab al-Shar'iyyah (Islamic Etiquettes)",
      "Usul al-Fiqh"
    ],
    notableFor: [
      "Student of Ibn Taymiyyah",
      "Authored definitive Hanbali fiqh reference",
      "Father of later Hanbali scholars"
    ],
    colorTheme: {
      primary: "from-red-500",
      secondary: "to-orange-600"
    }
  },
  {
    id: 87,
    name: "Al-Mardawi",
    arabicName: "المرداوي",
    title: "Judge of Damascus",
    born: { hijri: 817, gregorian: 1414 },
    died: { hijri: 885, gregorian: 1480 },
    location: "Damascus, Syria",
    rarity: "epic",
    level: 88,
    era: "Late Medieval",
    madhab: "Hanbali",
    expertise: ["Fiqh", "Comparative Law", "Legal Weighting"],
    specialAbility: "Arbiter of Hanbali Opinions",
    stats: {
      knowledge: 93,
      influence: 84,
      piety: 88,
      works: 91,
      leadership: 80
    },
    bio: "Ala al-Din al-Mardawi was a Hanbali jurist known for his encyclopedic work 'Al-Insaf' which definitively weighs competing opinions within the Hanbali school, making it the authoritative reference for the madhab's positions.",
    majorWorks: [
      "Al-Insaf fi Ma'rifat al-Rajih (Fairness in Knowing the Preferred View)",
      "Al-Tanqih al-Mushbi' (Satisfying Refinement)",
      "Tahrir al-Manqul"
    ],
    notableFor: [
      "Definitive arbiter of Hanbali positions",
      "Chief judge of Damascus",
      "Teacher of al-Hajjawi"
    ],
    colorTheme: {
      primary: "from-red-500",
      secondary: "to-pink-600"
    }
  },
  {
    id: 88,
    name: "Al-Hajjawi",
    arabicName: "الحجاوي",
    title: "Author of Zad al-Mustaqni'",
    born: { hijri: 895, gregorian: 1490 },
    died: { hijri: 968, gregorian: 1560 },
    location: "Damascus, Syria",
    rarity: "epic",
    level: 87,
    era: "Late Medieval",
    madhab: "Hanbali",
    expertise: ["Fiqh", "Legal Summarization"],
    specialAbility: "Master of Concise Fiqh",
    stats: {
      knowledge: 90,
      influence: 88,
      piety: 89,
      works: 85,
      leadership: 76
    },
    bio: "Musa ibn Ahmad al-Hajjawi was a Palestinian-origin Hanbali scholar whose 'Zad al-Mustaqni'' became the most memorized and studied text in the Hanbali school, forming the basis for centuries of Hanbali education.",
    majorWorks: [
      "Zad al-Mustaqni' (Provisions for the Seeker)",
      "Al-Iqna' (Convincing)",
      "Sharh al-Muqni'"
    ],
    notableFor: [
      "Most memorized Hanbali fiqh text",
      "Basis of Hanbali curriculum for centuries",
      "Student of al-Mardawi"
    ],
    colorTheme: {
      primary: "from-red-500",
      secondary: "to-rose-600"
    }
  },

  // ==========================================
  // FEMALE SCHOLARS (New Additions)
  // ==========================================
  {
    id: 89,
    name: "Fatima al-Fihri",
    arabicName: "فاطمة الفهري",
    title: "Founder of Al-Qarawiyyin",
    born: { hijri: 185, gregorian: 800 },
    died: { hijri: 265, gregorian: 880 },
    location: "Fez, Morocco",
    rarity: "legendary",
    level: 95,
    era: "Medieval",
    madhab: "Maliki",
    expertise: ["Education", "Patronage", "Religious Endowment"],
    specialAbility: "Mother of Universities",
    stats: {
      knowledge: 85,
      influence: 99,
      piety: 95,
      works: 80,
      leadership: 92
    },
    bio: "Fatima al-Fihri was a Muslim woman who founded the University of al-Qarawiyyin in Fez in 859 CE, recognized by UNESCO and Guinness World Records as the oldest existing, continually operating educational institution in the world.",
    majorWorks: [
      "Founded University of al-Qarawiyyin (859 CE)",
      "Established al-Qarawiyyin Mosque",
      "Created first university library"
    ],
    notableFor: [
      "Founded world's oldest operating university",
      "Daughter of wealthy merchant from Qayrawan",
      "Used inheritance for religious endowment"
    ],
    colorTheme: {
      primary: "from-purple-500",
      secondary: "to-pink-600"
    }
  },
  {
    id: 90,
    name: "Nafisa bint al-Hasan",
    arabicName: "نفيسة بنت الحسن",
    title: "Jewel of Knowledge",
    born: { hijri: 145, gregorian: 762 },
    died: { hijri: 208, gregorian: 824 },
    location: "Cairo, Egypt",
    rarity: "legendary",
    level: 93,
    era: "Early Scholars",
    madhab: "",
    expertise: ["Hadith", "Fiqh", "Spirituality", "Teaching"],
    specialAbility: "Teacher of Imam al-Shafi'i",
    stats: {
      knowledge: 95,
      influence: 90,
      piety: 99,
      works: 75,
      leadership: 85
    },
    bio: "Sayyida Nafisa bint al-Hasan was a great-granddaughter of Hasan ibn Ali and descendant of the Prophet. She was so revered for her knowledge that Imam al-Shafi'i studied with her and requested she pray his funeral prayer when he died.",
    majorWorks: [
      "Hadith transmission",
      "Teaching circles in Cairo",
      "Famous for her supplications (du'a)"
    ],
    notableFor: [
      "Taught Imam al-Shafi'i",
      "Prayed funeral prayer for al-Shafi'i",
      "Memorized entire Quran as a child",
      "Performed Hajj over 30 times"
    ],
    colorTheme: {
      primary: "from-emerald-500",
      secondary: "to-teal-600"
    }
  },
  {
    id: 91,
    name: "Karima al-Marwaziyya",
    arabicName: "كريمة المروزية",
    title: "Authority on Sahih Bukhari",
    born: { hijri: 363, gregorian: 974 },
    died: { hijri: 463, gregorian: 1070 },
    location: "Mecca, Saudi Arabia",
    rarity: "epic",
    level: 91,
    era: "Medieval",
    madhab: "",
    expertise: ["Hadith", "Sahih Bukhari", "Teaching"],
    specialAbility: "Keeper of Bukhari's Chain",
    stats: {
      knowledge: 96,
      influence: 88,
      piety: 94,
      works: 70,
      leadership: 80
    },
    bio: "Karima bint Ahmad al-Marwaziyya was considered the highest authority on Sahih al-Bukhari in her time. Scholars traveled from across the Muslim world to receive ijazah (authorization) from her, as her chain to Bukhari was the most authenticated.",
    majorWorks: [
      "Transmission of Sahih al-Bukhari",
      "Teaching in Mecca for decades",
      "Granted ijazah to countless scholars"
    ],
    notableFor: [
      "Highest authority on Sahih Bukhari",
      "Scholars traveled worldwide to learn from her",
      "Taught at the Haram in Mecca",
      "Lived past 100 years"
    ],
    colorTheme: {
      primary: "from-amber-500",
      secondary: "to-yellow-600"
    }
  },
  {
    id: 92,
    name: "Fatima bint al-Mundhir",
    arabicName: "فاطمة بنت المنذر",
    title: "Hadith Scholar of Medina",
    born: { hijri: 48, gregorian: 668 },
    died: { hijri: 105, gregorian: 724 },
    location: "Medina, Saudi Arabia",
    rarity: "epic",
    level: 88,
    era: "Tabi'un",
    madhab: "",
    expertise: ["Hadith", "Narration"],
    specialAbility: "Chain to Asma bint Abi Bakr",
    stats: {
      knowledge: 90,
      influence: 82,
      piety: 92,
      works: 65,
      leadership: 70
    },
    bio: "Fatima bint al-Mundhir ibn al-Zubayr was a major hadith narrator among the Tabi'un. She was the wife of Hisham ibn Urwa and transmitted hadith from her grandmother Asma bint Abi Bakr and other companions.",
    majorWorks: [
      "Hadith transmission from Companions",
      "Key narrator in Sahih collections"
    ],
    notableFor: [
      "Wife of Hisham ibn Urwa",
      "Granddaughter of Asma bint Abi Bakr",
      "Her hadiths in Bukhari and Muslim"
    ],
    colorTheme: {
      primary: "from-rose-500",
      secondary: "to-pink-600"
    }
  },
  {
    id: 93,
    name: "Umm al-Darda al-Sughra",
    arabicName: "أم الدرداء الصغرى",
    title: "Scholar of Damascus",
    born: { hijri: 30, gregorian: 650 },
    died: { hijri: 81, gregorian: 700 },
    location: "Damascus, Syria",
    rarity: "epic",
    level: 89,
    era: "Tabi'un",
    madhab: "",
    expertise: ["Fiqh", "Hadith", "Teaching"],
    specialAbility: "Teacher in the Grand Mosque",
    stats: {
      knowledge: 92,
      influence: 86,
      piety: 95,
      works: 68,
      leadership: 84
    },
    bio: "Umm al-Darda al-Sughra was one of the greatest female scholars of the Tabi'un. She taught in the men's section of the Umayyad Mosque in Damascus and was so respected that Caliph Abd al-Malik ibn Marwan studied with her.",
    majorWorks: [
      "Teaching circles in Umayyad Mosque",
      "Hadith transmission from Abu al-Darda"
    ],
    notableFor: [
      "Taught in men's section of Damascus mosque",
      "Teacher of Caliph Abd al-Malik",
      "Spent six months yearly in Jerusalem"
    ],
    colorTheme: {
      primary: "from-indigo-500",
      secondary: "to-purple-600"
    }
  },
  {
    id: 94,
    name: "Shuhda al-Katiba",
    arabicName: "شهدة الكاتبة",
    title: "Pride of Women",
    born: { hijri: 522, gregorian: 1128 },
    died: { hijri: 574, gregorian: 1178 },
    location: "Baghdad, Iraq",
    rarity: "epic",
    level: 88,
    era: "Medieval",
    madhab: "",
    expertise: ["Hadith", "Calligraphy", "Teaching"],
    specialAbility: "Master Calligrapher and Scholar",
    stats: {
      knowledge: 90,
      influence: 87,
      piety: 89,
      works: 82,
      leadership: 78
    },
    bio: "Shuhda bint al-Ibari, known as 'Fakhr al-Nisa' (Pride of Women), was a renowned hadith scholar and calligrapher in Baghdad. She taught hadith for decades and was famous for her beautiful handwriting of religious texts.",
    majorWorks: [
      "Hadith transmission with high chains",
      "Calligraphic copies of religious texts",
      "Teaching until past age 90"
    ],
    notableFor: [
      "Called 'Pride of Women' for her scholarship",
      "Master calligrapher",
      "Taught hadith for over 50 years"
    ],
    colorTheme: {
      primary: "from-fuchsia-500",
      secondary: "to-pink-600"
    }
  },
  {
    id: 95,
    name: "Zaynab bint al-Kamal",
    arabicName: "زينب بنت الكمال",
    title: "Scholar of Damascus",
    born: { hijri: 646, gregorian: 1248 },
    died: { hijri: 740, gregorian: 1339 },
    location: "Damascus, Syria",
    rarity: "epic",
    level: 89,
    era: "Late Medieval",
    madhab: "",
    expertise: ["Hadith", "Teaching"],
    specialAbility: "Link in Golden Chain",
    stats: {
      knowledge: 91,
      influence: 85,
      piety: 92,
      works: 72,
      leadership: 79
    },
    bio: "Zaynab bint al-Kamal al-Maqdisiyya was one of the most distinguished hadith scholars of her era. She held ijazah from over 400 teachers and granted authorization to many scholars including teachers of Ibn Hajar al-Asqalani.",
    majorWorks: [
      "Hadith transmission",
      "Teaching circles in Damascus",
      "Granted ijazah to major scholars"
    ],
    notableFor: [
      "Received ijazah from 400+ teachers",
      "In the chain to Ibn Hajar al-Asqalani",
      "Called 'Musnida al-Sham' (Hadith Authority of Syria)"
    ],
    colorTheme: {
      primary: "from-violet-500",
      secondary: "to-purple-600"
    }
  },
  {
    id: 96,
    name: "Fatima al-Samarqandiyya",
    arabicName: "فاطمة السمرقندية",
    title: "The Lady Jurist",
    born: { hijri: 520, gregorian: 1126 },
    died: { hijri: 581, gregorian: 1185 },
    location: "Aleppo, Syria",
    rarity: "epic",
    level: 87,
    era: "Medieval",
    madhab: "Hanafi",
    expertise: ["Fiqh", "Fatwa", "Jurisprudence"],
    specialAbility: "Corrector of Fatwas",
    stats: {
      knowledge: 93,
      influence: 82,
      piety: 88,
      works: 75,
      leadership: 80
    },
    bio: "Fatima al-Samarqandiyya was a Hanafi jurist, daughter of the author of 'Tuhfat al-Fuqaha'. She was so learned that her husband, al-Kasani, would consult her on fatwas and she would correct his legal opinions.",
    majorWorks: [
      "Advisory role in husband's 'Bada'i al-Sana'i'",
      "Fatwa corrections and consultations"
    ],
    notableFor: [
      "Daughter of author of Tuhfat al-Fuqaha",
      "Corrected her husband's fatwas",
      "Her signature appeared on fatwas alongside husband"
    ],
    colorTheme: {
      primary: "from-amber-500",
      secondary: "to-orange-600"
    }
  },
  {
    id: 97,
    name: "Aisha bint Sa'd",
    arabicName: "عائشة بنت سعد",
    title: "Teacher of Imam Malik",
    born: { hijri: 55, gregorian: 675 },
    died: { hijri: 117, gregorian: 735 },
    location: "Medina, Saudi Arabia",
    rarity: "epic",
    level: 88,
    era: "Tabi'un",
    madhab: "",
    expertise: ["Hadith", "Fiqh", "Teaching"],
    specialAbility: "Link to the Prophet's Companions",
    stats: {
      knowledge: 90,
      influence: 84,
      piety: 91,
      works: 68,
      leadership: 75
    },
    bio: "Aisha bint Sa'd ibn Abi Waqqas was a prominent Tabi'i scholar and daughter of the companion Sa'd ibn Abi Waqqas. She narrated hadith from her father and taught Imam Malik and other major scholars.",
    majorWorks: [
      "Hadith transmission from her father Sa'd",
      "Teaching future scholars of Medina"
    ],
    notableFor: [
      "Daughter of Sa'd ibn Abi Waqqas",
      "Taught Imam Malik ibn Anas",
      "Her hadiths in major collections"
    ],
    colorTheme: {
      primary: "from-teal-500",
      secondary: "to-cyan-600"
    }
  },
  {
    id: 98,
    name: "Fatima bint Yahya",
    arabicName: "فاطمة بنت يحيى",
    title: "Last of the Great Muhaddithat",
    born: { hijri: 710, gregorian: 1310 },
    died: { hijri: 789, gregorian: 1387 },
    location: "Damascus, Syria",
    rarity: "epic",
    level: 86,
    era: "Late Medieval",
    madhab: "",
    expertise: ["Hadith", "Teaching"],
    specialAbility: "Keeper of High Chains",
    stats: {
      knowledge: 88,
      influence: 82,
      piety: 90,
      works: 70,
      leadership: 74
    },
    bio: "Fatima bint Yahya was among the last major female hadith transmitters of the classical period. She held high chains of transmission and was sought by scholars seeking authenticated routes to early sources.",
    majorWorks: [
      "Hadith transmission",
      "Teaching scholars from across Muslim lands"
    ],
    notableFor: [
      "Among last great female muhaddithat",
      "Preserved high chains of narration",
      "Taught in Damascus"
    ],
    colorTheme: {
      primary: "from-rose-500",
      secondary: "to-red-600"
    }
  },

  // ==========================================
  // OTHER MADHABS - HANAFI SCHOLARS
  // ==========================================
  {
    id: 99,
    name: "Al-Kasani",
    arabicName: "الكاساني",
    title: "King of Scholars",
    born: { hijri: 500, gregorian: 1106 },
    died: { hijri: 587, gregorian: 1191 },
    location: "Aleppo, Syria",
    rarity: "legendary",
    level: 93,
    era: "Medieval",
    madhab: "Hanafi",
    expertise: ["Fiqh", "Legal Theory", "Comparative Law"],
    specialAbility: "Master of Legal Deduction",
    stats: {
      knowledge: 96,
      influence: 90,
      piety: 88,
      works: 94,
      leadership: 82
    },
    bio: "Ala al-Din al-Kasani was a Hanafi jurist whose 'Bada'i al-Sana'i fi Tartib al-Shara'i' is considered one of the finest works of Hanafi jurisprudence. He married Fatima al-Samarqandiyya and their household was a center of scholarship.",
    majorWorks: [
      "Bada'i al-Sana'i fi Tartib al-Shara'i (Marvels of Creation in Ordering the Laws)"
    ],
    notableFor: [
      "Called 'Malik al-Ulama' (King of Scholars)",
      "His work is a primary Hanafi reference",
      "Married the scholar Fatima al-Samarqandiyya"
    ],
    colorTheme: {
      primary: "from-yellow-500",
      secondary: "to-amber-600"
    }
  },
  {
    id: 100,
    name: "Ibn Abidin",
    arabicName: "ابن عابدين",
    title: "Seal of Hanafi Verifiers",
    born: { hijri: 1198, gregorian: 1784 },
    died: { hijri: 1252, gregorian: 1836 },
    location: "Damascus, Syria",
    rarity: "legendary",
    level: 94,
    era: "Modern",
    madhab: "Hanafi",
    expertise: ["Fiqh", "Fatwa", "Legal Commentary"],
    specialAbility: "The Final Word in Hanafi Fiqh",
    stats: {
      knowledge: 97,
      influence: 95,
      piety: 90,
      works: 96,
      leadership: 85
    },
    bio: "Muhammad Amin ibn Abidin was the greatest Hanafi scholar of the Ottoman era. His 'Radd al-Muhtar ala al-Durr al-Mukhtar' (known as 'Ibn Abidin') is the definitive reference for Hanafi fatwa to this day.",
    majorWorks: [
      "Radd al-Muhtar ala al-Durr al-Mukhtar (Hashiyat Ibn Abidin)",
      "Majmu'at Rasa'il Ibn Abidin"
    ],
    notableFor: [
      "Final authority in Hanafi fiqh",
      "His work is the fatwa reference for Hanafis",
      "Called 'Khatam al-Muhaqqiqin' (Seal of Verifiers)"
    ],
    colorTheme: {
      primary: "from-yellow-600",
      secondary: "to-orange-600"
    }
  },
  {
    id: 101,
    name: "Al-Marghinani",
    arabicName: "المرغيناني",
    title: "Author of Al-Hidayah",
    born: { hijri: 511, gregorian: 1117 },
    died: { hijri: 593, gregorian: 1197 },
    location: "Marghinan, Uzbekistan",
    rarity: "legendary",
    level: 93,
    era: "Medieval",
    madhab: "Hanafi",
    expertise: ["Fiqh", "Legal Methodology"],
    specialAbility: "Guide of Hanafi Scholars",
    stats: {
      knowledge: 95,
      influence: 94,
      piety: 89,
      works: 92,
      leadership: 80
    },
    bio: "Burhan al-Din al-Marghinani was a Central Asian Hanafi jurist whose 'Al-Hidayah' became the most widely studied Hanafi fiqh text globally. It remains the standard curriculum text in South Asian Islamic schools.",
    majorWorks: [
      "Al-Hidayah fi Sharh Bidayat al-Mubtadi (The Guidance)",
      "Bidayat al-Mubtadi"
    ],
    notableFor: [
      "Al-Hidayah is the most studied Hanafi text",
      "Standard curriculum in South Asian madrassas",
      "Spent 13 years writing Al-Hidayah"
    ],
    colorTheme: {
      primary: "from-yellow-500",
      secondary: "to-lime-600"
    }
  },
  {
    id: 102,
    name: "Al-Tahawi",
    arabicName: "الطحاوي",
    title: "Master of Creed and Fiqh",
    born: { hijri: 239, gregorian: 853 },
    died: { hijri: 321, gregorian: 933 },
    location: "Cairo, Egypt",
    rarity: "legendary",
    level: 94,
    era: "Medieval",
    madhab: "Hanafi",
    expertise: ["Aqeedah", "Hadith", "Fiqh"],
    specialAbility: "Definer of Sunni Creed",
    stats: {
      knowledge: 96,
      influence: 93,
      piety: 92,
      works: 90,
      leadership: 84
    },
    bio: "Abu Ja'far al-Tahawi was an Egyptian Hanafi scholar whose 'Al-Aqidah al-Tahawiyya' is one of the most widely accepted statements of Sunni creed. Originally Shafi'i, he later became the leading Hanafi of Egypt.",
    majorWorks: [
      "Al-Aqidah al-Tahawiyya (The Tahawi Creed)",
      "Sharh Ma'ani al-Athar",
      "Mushkil al-Athar"
    ],
    notableFor: [
      "Author of most accepted Sunni creed statement",
      "Nephew of Imam al-Muzani (Shafi'i)",
      "Converted from Shafi'i to Hanafi madhab"
    ],
    colorTheme: {
      primary: "from-yellow-500",
      secondary: "to-gold-600"
    }
  },

  // ==========================================
  // OTHER MADHABS - MALIKI SCHOLARS
  // ==========================================
  {
    id: 103,
    name: "Qadi Iyad",
    arabicName: "القاضي عياض",
    title: "Master of Shifa",
    born: { hijri: 476, gregorian: 1083 },
    died: { hijri: 544, gregorian: 1149 },
    location: "Ceuta, Morocco",
    rarity: "legendary",
    level: 94,
    era: "Medieval",
    madhab: "Maliki",
    expertise: ["Seerah", "Hadith", "Fiqh"],
    specialAbility: "Healer of Hearts",
    stats: {
      knowledge: 95,
      influence: 93,
      piety: 94,
      works: 92,
      leadership: 88
    },
    bio: "Qadi Iyad ibn Musa al-Yahsubi was the leading Maliki scholar of his era and author of 'Al-Shifa bi Ta'rif Huquq al-Mustafa', the most beloved book on the Prophet's life and rights after hadith collections.",
    majorWorks: [
      "Al-Shifa bi Ta'rif Huquq al-Mustafa",
      "Tartib al-Madarik (Biographies of Maliki Scholars)",
      "Ikmal al-Mu'lim (Commentary on Sahih Muslim)"
    ],
    notableFor: [
      "Al-Shifa is read for blessings worldwide",
      "Chief judge of Ceuta and Granada",
      "Died defending Islam against Almohads"
    ],
    colorTheme: {
      primary: "from-purple-500",
      secondary: "to-violet-600"
    }
  },
  {
    id: 104,
    name: "Ibn Rushd al-Jadd",
    arabicName: "ابن رشد الجد",
    title: "Grandfather Scholar",
    born: { hijri: 450, gregorian: 1058 },
    died: { hijri: 520, gregorian: 1126 },
    location: "Cordoba, Spain",
    rarity: "epic",
    level: 90,
    era: "Medieval",
    madhab: "Maliki",
    expertise: ["Fiqh", "Fatwa", "Quranic Sciences"],
    specialAbility: "Master of Andalusian Fiqh",
    stats: {
      knowledge: 93,
      influence: 89,
      piety: 90,
      works: 88,
      leadership: 86
    },
    bio: "Abu al-Walid Muhammad ibn Rushd (the grandfather) was the chief judge of Cordoba and leading Maliki scholar of al-Andalus. His fatwas and legal works were authoritative in the Islamic West. He was the grandfather of the philosopher Ibn Rushd.",
    majorWorks: [
      "Al-Bayan wa al-Tahsil",
      "Al-Muqaddimat al-Mumahhadat",
      "Fatawa Ibn Rushd"
    ],
    notableFor: [
      "Chief judge of Cordoba",
      "Grandfather of philosopher Ibn Rushd",
      "Leading authority in Andalusian Maliki law"
    ],
    colorTheme: {
      primary: "from-purple-500",
      secondary: "to-fuchsia-600"
    }
  },
  {
    id: 105,
    name: "Al-Qarafi",
    arabicName: "القرافي",
    title: "Master of Legal Maxims",
    born: { hijri: 626, gregorian: 1228 },
    died: { hijri: 684, gregorian: 1285 },
    location: "Cairo, Egypt",
    rarity: "legendary",
    level: 93,
    era: "Late Medieval",
    madhab: "Maliki",
    expertise: ["Usul al-Fiqh", "Legal Maxims", "Comparative Law"],
    specialAbility: "Distinguisher of Differences",
    stats: {
      knowledge: 96,
      influence: 90,
      piety: 88,
      works: 94,
      leadership: 82
    },
    bio: "Shihab al-Din al-Qarafi was an Egyptian Maliki jurist famous for 'Al-Furuq' (The Distinctions), which analyzes subtle differences between similar legal cases. His works on usul al-fiqh influenced all madhabs.",
    majorWorks: [
      "Al-Furuq (The Distinctions)",
      "Al-Dhakhira (The Treasury)",
      "Nafais al-Usul fi Sharh al-Mahsul"
    ],
    notableFor: [
      "Pioneer of legal maxims (qawa'id fiqhiyyah)",
      "His Furuq studied across all madhabs",
      "Also known as an astronomer and mathematician"
    ],
    colorTheme: {
      primary: "from-purple-600",
      secondary: "to-indigo-600"
    }
  },
  {
    id: 106,
    name: "Khalil ibn Ishaq",
    arabicName: "خليل بن إسحاق",
    title: "Author of Mukhtasar Khalil",
    born: { hijri: 690, gregorian: 1291 },
    died: { hijri: 776, gregorian: 1374 },
    location: "Cairo, Egypt",
    rarity: "epic",
    level: 91,
    era: "Late Medieval",
    madhab: "Maliki",
    expertise: ["Fiqh", "Legal Summarization"],
    specialAbility: "Condenser of Maliki Law",
    stats: {
      knowledge: 92,
      influence: 94,
      piety: 87,
      works: 88,
      leadership: 78
    },
    bio: "Khalil ibn Ishaq al-Jundi was an Egyptian Maliki jurist whose 'Mukhtasar' became the most authoritative summary of Maliki fiqh. It is the primary text studied in North and West Africa to this day.",
    majorWorks: [
      "Mukhtasar Khalil (Summary of Khalil)",
      "Al-Tawdih (The Clarification)"
    ],
    notableFor: [
      "His Mukhtasar is THE Maliki fiqh text",
      "Over 50 commentaries written on it",
      "Standard curriculum across Africa"
    ],
    colorTheme: {
      primary: "from-purple-500",
      secondary: "to-pink-600"
    }
  },

  // ==========================================
  // OTHER MADHABS - SHAFI'I SCHOLARS
  // ==========================================
  {
    id: 107,
    name: "Al-Juwayni",
    arabicName: "الجويني",
    title: "Imam of the Two Harams",
    born: { hijri: 419, gregorian: 1028 },
    died: { hijri: 478, gregorian: 1085 },
    location: "Nishapur, Iran",
    rarity: "legendary",
    level: 95,
    era: "Medieval",
    madhab: "Shafi'i",
    expertise: ["Usul al-Fiqh", "Kalam", "Fiqh"],
    specialAbility: "Master of Legal Theory",
    stats: {
      knowledge: 98,
      influence: 92,
      piety: 88,
      works: 94,
      leadership: 90
    },
    bio: "Abu al-Ma'ali al-Juwayni, titled 'Imam al-Haramayn' for teaching in Mecca and Medina, was among the greatest Shafi'i scholars. His 'Kitab al-Irshad' and legal theory works shaped all subsequent Islamic scholarship. He was the teacher of al-Ghazali.",
    majorWorks: [
      "Kitab al-Irshad (Book of Guidance)",
      "Al-Burhan fi Usul al-Fiqh",
      "Nihayat al-Matlab"
    ],
    notableFor: [
      "Teacher of Imam al-Ghazali",
      "Called 'Imam of the Two Harams'",
      "Revolutionized usul al-fiqh methodology"
    ],
    colorTheme: {
      primary: "from-green-500",
      secondary: "to-emerald-600"
    }
  },
  {
    id: 108,
    name: "Al-Rafi'i",
    arabicName: "الرافعي",
    title: "Pillar of Shafi'i Fiqh",
    born: { hijri: 555, gregorian: 1160 },
    died: { hijri: 623, gregorian: 1226 },
    location: "Qazvin, Iran",
    rarity: "epic",
    level: 91,
    era: "Medieval",
    madhab: "Shafi'i",
    expertise: ["Fiqh", "Hadith"],
    specialAbility: "Systematizer of Late Shafi'i School",
    stats: {
      knowledge: 94,
      influence: 88,
      piety: 90,
      works: 91,
      leadership: 80
    },
    bio: "Abd al-Karim al-Rafi'i al-Qazwini was a Persian Shafi'i jurist whose works systematized the later Shafi'i school. His 'Al-Aziz Sharh al-Wajiz' forms the basis for al-Nawawi's famous works.",
    majorWorks: [
      "Al-Aziz Sharh al-Wajiz (Fath al-Aziz)",
      "Al-Tadwin fi Akhbar Qazwin"
    ],
    notableFor: [
      "Foundation for al-Nawawi's Rawda and Minhaj",
      "Paired with al-Nawawi as 'The Two Shaykhs'",
      "His tarjih (preference) is authoritative"
    ],
    colorTheme: {
      primary: "from-green-500",
      secondary: "to-teal-600"
    }
  },
  {
    id: 109,
    name: "Ibn Hajar al-Haytami",
    arabicName: "ابن حجر الهيتمي",
    title: "Mufti of Mecca",
    born: { hijri: 909, gregorian: 1503 },
    died: { hijri: 974, gregorian: 1566 },
    location: "Mecca, Saudi Arabia",
    rarity: "legendary",
    level: 93,
    era: "Late Medieval",
    madhab: "Shafi'i",
    expertise: ["Fiqh", "Fatwa", "Ethics"],
    specialAbility: "Authority on Major Sins",
    stats: {
      knowledge: 95,
      influence: 92,
      piety: 90,
      works: 93,
      leadership: 85
    },
    bio: "Ahmad ibn Hajar al-Haytami was the leading Shafi'i scholar of his era and Mufti of Mecca. His 'Tuhfat al-Muhtaj' is one of the two authoritative late Shafi'i references (with Nihayat al-Muhtaj).",
    majorWorks: [
      "Tuhfat al-Muhtaj bi Sharh al-Minhaj",
      "Al-Zawajir 'an Iqtiraf al-Kaba'ir",
      "Al-Fatawa al-Kubra"
    ],
    notableFor: [
      "Tuhfat al-Muhtaj is Shafi'i fatwa reference",
      "His 'Zawajir' on major sins widely studied",
      "Mufti of Mecca and the Shafi'i world"
    ],
    colorTheme: {
      primary: "from-green-600",
      secondary: "to-emerald-700"
    }
  },
  {
    id: 110,
    name: "Al-Ramli",
    arabicName: "الرملي",
    title: "Little Shafi'i",
    born: { hijri: 919, gregorian: 1513 },
    died: { hijri: 1004, gregorian: 1596 },
    location: "Cairo, Egypt",
    rarity: "legendary",
    level: 92,
    era: "Late Medieval",
    madhab: "Shafi'i",
    expertise: ["Fiqh", "Fatwa"],
    specialAbility: "Egyptian Shafi'i Authority",
    stats: {
      knowledge: 94,
      influence: 91,
      piety: 89,
      works: 92,
      leadership: 84
    },
    bio: "Shams al-Din al-Ramli was called 'al-Shafi'i al-Saghir' (the Little Shafi'i) for his mastery of the school. His 'Nihayat al-Muhtaj' is the other authoritative late Shafi'i reference alongside Ibn Hajar al-Haytami's work.",
    majorWorks: [
      "Nihayat al-Muhtaj ila Sharh al-Minhaj",
      "Fatawa al-Ramli"
    ],
    notableFor: [
      "Called 'the Little Shafi'i' for his mastery",
      "Nihayat al-Muhtaj is Shafi'i fatwa reference",
      "His views followed in Egypt and Southeast Asia"
    ],
    colorTheme: {
      primary: "from-green-500",
      secondary: "to-lime-600"
    }
  },

  // ==========================================
  // ADDITIONAL NOTABLE SCHOLARS
  // ==========================================
  {
    id: 111,
    name: "Al-Suyuti",
    arabicName: "السيوطي",
    title: "Renewer of the Century",
    born: { hijri: 849, gregorian: 1445 },
    died: { hijri: 911, gregorian: 1505 },
    location: "Cairo, Egypt",
    rarity: "legendary",
    level: 96,
    era: "Late Medieval",
    madhab: "Shafi'i",
    expertise: ["Hadith", "Tafsir", "Arabic", "Fiqh", "History"],
    specialAbility: "Polymath of 500 Books",
    stats: {
      knowledge: 99,
      influence: 95,
      piety: 88,
      works: 99,
      leadership: 82
    },
    bio: "Jalal al-Din al-Suyuti was one of the most prolific scholars in Islamic history, authoring over 500 works on virtually every Islamic science. He claimed to have memorized 200,000 hadith and was considered the mujaddid (renewer) of his century.",
    majorWorks: [
      "Tafsir al-Jalalayn (with al-Mahalli)",
      "Al-Itqan fi Ulum al-Quran",
      "Al-Durr al-Manthur (Tafsir)",
      "Tadrib al-Rawi (Hadith Sciences)"
    ],
    notableFor: [
      "Authored over 500 works",
      "Memorized 200,000 hadith",
      "Considered mujaddid of 9th hijri century"
    ],
    colorTheme: {
      primary: "from-green-600",
      secondary: "to-teal-700"
    }
  },
  {
    id: 112,
    name: "Al-Izz ibn Abd al-Salam",
    arabicName: "العز بن عبد السلام",
    title: "Sultan of the Scholars",
    born: { hijri: 577, gregorian: 1181 },
    died: { hijri: 660, gregorian: 1262 },
    location: "Damascus/Cairo",
    rarity: "legendary",
    level: 94,
    era: "Medieval",
    madhab: "Shafi'i",
    expertise: ["Fiqh", "Legal Maxims", "Tafsir"],
    specialAbility: "Fearless Truth-Speaker",
    stats: {
      knowledge: 95,
      influence: 94,
      piety: 96,
      works: 90,
      leadership: 92
    },
    bio: "Al-Izz ibn Abd al-Salam was called 'Sultan al-Ulama' for his fearless scholarship. He publicly criticized rulers, sold Mamluk amirs to free them and give them rights, and authored 'Qawa'id al-Ahkam' on Islamic legal maxims.",
    majorWorks: [
      "Qawa'id al-Ahkam fi Masalih al-Anam",
      "Al-Qawa'id al-Kubra",
      "Tafsir al-Izz"
    ],
    notableFor: [
      "Called 'Sultan of the Scholars'",
      "Sold Mamluk amirs at auction for their rights",
      "Refused to fear any ruler"
    ],
    colorTheme: {
      primary: "from-green-600",
      secondary: "to-emerald-700"
    }
  },
  {
    id: 113,
    name: "Ibn Daqiq al-Eid",
    arabicName: "ابن دقيق العيد",
    title: "Master of Both Sciences",
    born: { hijri: 625, gregorian: 1228 },
    died: { hijri: 702, gregorian: 1302 },
    location: "Cairo, Egypt",
    rarity: "legendary",
    level: 93,
    era: "Late Medieval",
    madhab: "Shafi'i",
    expertise: ["Hadith", "Fiqh", "Usul"],
    specialAbility: "Unifier of Hadith and Fiqh",
    stats: {
      knowledge: 96,
      influence: 91,
      piety: 93,
      works: 89,
      leadership: 85
    },
    bio: "Taqi al-Din ibn Daqiq al-Eid was renowned for mastering both hadith and fiqh at the highest levels. His 'Ihkam al-Ahkam' commentary on hadith of rulings is considered a masterpiece synthesizing both sciences.",
    majorWorks: [
      "Ihkam al-Ahkam Sharh Umdat al-Ahkam",
      "Al-Ilmam bi Ahadith al-Ahkam",
      "Al-Iqtirah fi Bayan al-Istilah"
    ],
    notableFor: [
      "Mastered both hadith and fiqh sciences",
      "Chief judge of Egypt",
      "Called 'Mujtahid of his era'"
    ],
    colorTheme: {
      primary: "from-green-500",
      secondary: "to-cyan-600"
    }
  },
  {
    id: 114,
    name: "Al-Subki",
    arabicName: "السبكي",
    title: "Defender of Ash'ari Creed",
    born: { hijri: 683, gregorian: 1284 },
    died: { hijri: 756, gregorian: 1355 },
    location: "Cairo, Egypt",
    rarity: "epic",
    level: 91,
    era: "Late Medieval",
    madhab: "Shafi'i",
    expertise: ["Fiqh", "Aqeedah", "Usul"],
    specialAbility: "Guardian of Orthodoxy",
    stats: {
      knowledge: 94,
      influence: 89,
      piety: 88,
      works: 90,
      leadership: 86
    },
    bio: "Taqi al-Din al-Subki was a leading Shafi'i-Ash'ari scholar and father of Taj al-Din al-Subki. He served as chief judge and vigorously defended mainstream Sunni theology against what he saw as aberrations.",
    majorWorks: [
      "Al-Sayf al-Saqil (Response to Ibn Qayyim)",
      "Fatawa al-Subki",
      "Al-Durra al-Mudiyya"
    ],
    notableFor: [
      "Chief Shafi'i judge of Damascus",
      "Refuted Ibn Taymiyyah's positions",
      "Father of Taj al-Din al-Subki"
    ],
    controversialViews: [
      "Strongly opposed Ibn Taymiyyah's theology",
      "Wrote refutations of Hanbali positions"
    ],
    colorTheme: {
      primary: "from-green-500",
      secondary: "to-teal-600"
    }
  },
  {
    id: 115,
    name: "Al-Dhahabi",
    arabicName: "الذهبي",
    title: "Master of Rijal",
    born: { hijri: 673, gregorian: 1274 },
    died: { hijri: 748, gregorian: 1348 },
    location: "Damascus, Syria",
    rarity: "legendary",
    level: 95,
    era: "Late Medieval",
    madhab: "Shafi'i",
    expertise: ["Hadith", "Rijal", "History", "Biographies"],
    specialAbility: "Evaluator of Narrators",
    stats: {
      knowledge: 98,
      influence: 93,
      piety: 90,
      works: 97,
      leadership: 82
    },
    bio: "Shams al-Din al-Dhahabi was the greatest hadith critic and historian of his era. His 'Siyar A'lam al-Nubala' (Lives of Noble Figures) and 'Mizan al-I'tidal' on narrator criticism remain essential references.",
    majorWorks: [
      "Siyar A'lam al-Nubala (23 volumes)",
      "Mizan al-I'tidal (Narrator Criticism)",
      "Tarikh al-Islam",
      "Tadhkirat al-Huffaz"
    ],
    notableFor: [
      "Greatest hadith critic of his era",
      "Student of Ibn Taymiyyah",
      "Siyar remains essential biographical reference"
    ],
    colorTheme: {
      primary: "from-green-600",
      secondary: "to-emerald-600"
    }
  },
  {
    id: 116,
    name: "Al-Mizzi",
    arabicName: "المزي",
    title: "Master of Tahdhib",
    born: { hijri: 654, gregorian: 1256 },
    died: { hijri: 742, gregorian: 1341 },
    location: "Damascus, Syria",
    rarity: "epic",
    level: 92,
    era: "Late Medieval",
    madhab: "Shafi'i",
    expertise: ["Hadith", "Rijal", "Narrator Criticism"],
    specialAbility: "Organizer of Narrator Sciences",
    stats: {
      knowledge: 95,
      influence: 88,
      piety: 91,
      works: 93,
      leadership: 78
    },
    bio: "Jamal al-Din al-Mizzi was a leading hadith scholar whose 'Tahdhib al-Kamal' is the most comprehensive work on hadith narrator biographies. He was the teacher of al-Dhahabi and father-in-law of Ibn Kathir.",
    majorWorks: [
      "Tahdhib al-Kamal fi Asma' al-Rijal",
      "Tuhfat al-Ashraf bi Ma'rifat al-Atraf"
    ],
    notableFor: [
      "Tahdhib al-Kamal is definitive rijal reference",
      "Teacher of al-Dhahabi",
      "Father-in-law of Ibn Kathir"
    ],
    colorTheme: {
      primary: "from-green-500",
      secondary: "to-lime-600"
    }
  },
  {
    id: 117,
    name: "Al-Bayhaqi",
    arabicName: "البيهقي",
    title: "Master of Sunan",
    born: { hijri: 384, gregorian: 994 },
    died: { hijri: 458, gregorian: 1066 },
    location: "Nishapur, Iran",
    rarity: "legendary",
    level: 94,
    era: "Medieval",
    madhab: "Shafi'i",
    expertise: ["Hadith", "Fiqh", "Usul"],
    specialAbility: "Collector of Legal Hadith",
    stats: {
      knowledge: 96,
      influence: 92,
      piety: 93,
      works: 95,
      leadership: 80
    },
    bio: "Abu Bakr al-Bayhaqi was a Persian hadith master whose 'Al-Sunan al-Kubra' is the largest collection of legal hadith. His works defending Shafi'i fiqh with hadith evidence are monumental.",
    majorWorks: [
      "Al-Sunan al-Kubra (10 volumes)",
      "Ma'rifat al-Sunan wa al-Athar",
      "Shu'ab al-Iman",
      "Dala'il al-Nubuwwa"
    ],
    notableFor: [
      "Al-Sunan al-Kubra largest legal hadith collection",
      "Strong defender of Shafi'i madhab",
      "Collected evidence for Shafi'i positions"
    ],
    colorTheme: {
      primary: "from-green-600",
      secondary: "to-teal-600"
    }
  },
  {
    id: 118,
    name: "Ibn Abd al-Barr",
    arabicName: "ابن عبد البر",
    title: "Hadith Master of the West",
    born: { hijri: 368, gregorian: 978 },
    died: { hijri: 463, gregorian: 1071 },
    location: "Cordoba, Spain",
    rarity: "legendary",
    level: 94,
    era: "Medieval",
    madhab: "Maliki",
    expertise: ["Hadith", "Fiqh", "Biographies"],
    specialAbility: "Western Hadith Authority",
    stats: {
      knowledge: 96,
      influence: 92,
      piety: 90,
      works: 94,
      leadership: 84
    },
    bio: "Abu Umar ibn Abd al-Barr was the greatest hadith scholar of al-Andalus and Islamic West. His 'Al-Tamhid' and 'Al-Istidhkar' are masterful commentaries on Malik's Muwatta, and 'Al-Isti'ab' is a major companion biography.",
    majorWorks: [
      "Al-Tamhid lima fi al-Muwatta",
      "Al-Istidhkar",
      "Al-Isti'ab fi Ma'rifat al-Ashab",
      "Jami' Bayan al-Ilm wa Fadlihi"
    ],
    notableFor: [
      "Greatest hadith scholar of Islamic West",
      "His works spread hadith sciences in Andalus",
      "Considered equal to al-Khatib al-Baghdadi"
    ],
    colorTheme: {
      primary: "from-purple-600",
      secondary: "to-violet-600"
    }
  }
];

export default scholars;
